// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&family=Lexend:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
    :root {
        --background: 0 0% 100%;
        --foreground: 222 47% 11%;
        --card: 0 0% 100%;
        --card-foreground: 222 47% 11%;
        --popover: 0 0% 100%;
        --popover-foreground: 222 47% 11%;
        --primary: 198 93% 49%;
        --primary-foreground: 0 0% 100%;
        --secondary: 210 40% 96%;
        --secondary-foreground: 222 47% 11%;
        --muted: 210 40% 96%;
        --muted-foreground: 215 16% 47%;
        --accent: 198 93% 96%;
        --accent-foreground: 198 93% 35%;
        --destructive: 0 84.2% 60.2%;
        --destructive-foreground: 0 0% 98%;
        --border: 214 32% 91%;
        --input: 214 32% 91%;
        --ring: 198 93% 49%;
        --chart-1: 24 95% 53%;
        --chart-2: 198 93% 49%;
        --chart-3: 222 47% 21%;
        --chart-4: 39 93% 56%;
        --chart-5: 160 84% 39%;
        --radius: 0.5rem;
    }
    *{
  border-color: hsl(var(--border));
}
    body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
        font-family: "Inter", sans-serif;
}
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: "Manrope", sans-serif;
    }
    html,
    body,
    * {
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    html::-webkit-scrollbar,
    body::-webkit-scrollbar,
    *::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
    }
    [data-debug-wrapper="true"] {
        display: contents !important;
    }

    [data-debug-wrapper="true"] > * {
        margin-left: inherit;
        margin-right: inherit;
        margin-top: inherit;
        margin-bottom: inherit;
        padding-left: inherit;
        padding-right: inherit;
        padding-top: inherit;
        padding-bottom: inherit;
        column-gap: inherit;
        row-gap: inherit;
        gap: inherit;
        border-left-width: inherit;
        border-right-width: inherit;
        border-top-width: inherit;
        border-bottom-width: inherit;
        border-left-style: inherit;
        border-right-style: inherit;
        border-top-style: inherit;
        border-bottom-style: inherit;
        border-left-color: inherit;
        border-right-color: inherit;
        border-top-color: inherit;
        border-bottom-color: inherit;
    }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-1{
  left: -0.25rem;
}
.-left-12{
  left: -3rem;
}
.-left-\\[27px\\]{
  left: -27px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-12{
  right: -3rem;
}
.-right-5{
  right: -1.25rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-12{
  top: -3rem;
}
.-top-5{
  top: -1.25rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-0\\.5{
  bottom: 0.125rem;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-\\[calc\\(3\\.75rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
  bottom: calc(3.75rem + env(safe-area-inset-bottom));
}
.bottom-\\[calc\\(5rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
  bottom: calc(5rem + env(safe-area-inset-bottom));
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-10{
  right: 2.5rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-\\[34px\\]{
  right: 34px;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-9{
  top: 2.25rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-\\[61px\\]{
  top: 61px;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[65\\]{
  z-index: 65;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[75\\]{
  z-index: 75;
}
.z-\\[80\\]{
  z-index: 80;
}
.z-\\[90\\]{
  z-index: 90;
}
.z-\\[95\\]{
  z-index: 95;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.order-last{
  order: 9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-full{
  grid-column: 1 / -1;
}
.col-start-1{
  grid-column-start: 1;
}
.col-start-2{
  grid-column-start: 2;
}
.col-start-3{
  grid-column-start: 3;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.row-start-1{
  grid-row-start: 1;
}
.row-start-2{
  grid-row-start: 2;
}
.row-start-3{
  grid-row-start: 3;
}
.m-4{
  margin: 1rem;
}
.m-auto{
  margin: auto;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5{
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.\\!mt-8{
  margin-top: 2rem !important;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-1\\.5{
  margin-left: -0.375rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-1\\.5{
  margin-right: -0.375rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.\\!h-\\[70vh\\]{
  height: 70vh !important;
}
.h-0{
  height: 0px;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[0\\.96rem\\]{
  height: 0.96rem;
}
.h-\\[1\\.2rem\\]{
  height: 1.2rem;
}
.h-\\[1\\.3rem\\]{
  height: 1.3rem;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[430px\\]{
  height: 430px;
}
.h-\\[6\\.5px\\]{
  height: 6.5px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[85vh\\]{
  height: 85vh;
}
.h-\\[95vh\\]{
  height: 95vh;
}
.h-\\[calc\\(100vh-1\\.5rem\\)\\]{
  height: calc(100vh - 1.5rem);
}
.h-\\[calc\\(100vh-1rem\\)\\]{
  height: calc(100vh - 1rem);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-28{
  max-height: 7rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-36{
  max-height: 9rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[100vh\\]{
  max-height: 100vh;
}
.max-h-\\[240px\\]{
  max-height: 240px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[340px\\]{
  max-height: 340px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[72vh\\]{
  max-height: 72vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85dvh\\]{
  max-height: 85dvh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[86vh\\]{
  max-height: 86vh;
}
.max-h-\\[88vh\\]{
  max-height: 88vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[94vh\\]{
  max-height: 94vh;
}
.max-h-\\[95vh\\]{
  max-height: 95vh;
}
.max-h-\\[calc\\(100dvh-1\\.5rem\\)\\]{
  max-height: calc(100dvh - 1.5rem);
}
.max-h-\\[calc\\(100dvh-2rem\\)\\]{
  max-height: calc(100dvh - 2rem);
}
.max-h-\\[calc\\(100vh-1\\.5rem\\)\\]{
  max-height: calc(100vh - 1.5rem);
}
.max-h-\\[calc\\(100vh-1rem\\)\\]{
  max-height: calc(100vh - 1rem);
}
.max-h-\\[calc\\(100vh-2rem\\)\\]{
  max-height: calc(100vh - 2rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-\\[var\\(--radix-popover-content-available-height\\)\\]{
  max-height: var(--radix-popover-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-\\[1\\.5rem\\]{
  min-height: 1.5rem;
}
.min-h-\\[1\\.75rem\\]{
  min-height: 1.75rem;
}
.min-h-\\[13rem\\]{
  min-height: 13rem;
}
.min-h-\\[2\\.3em\\]{
  min-height: 2.3em;
}
.min-h-\\[2\\.5em\\]{
  min-height: 2.5em;
}
.min-h-\\[2\\.75rem\\]{
  min-height: 2.75rem;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[3\\.25rem\\]{
  min-height: 3.25rem;
}
.min-h-\\[3\\.5rem\\]{
  min-height: 3.5rem;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[0\\.96rem\\]{
  width: 0.96rem;
}
.w-\\[1\\.2rem\\]{
  width: 1.2rem;
}
.w-\\[1\\.3rem\\]{
  width: 1.3rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[11\\%\\]{
  width: 11%;
}
.w-\\[112px\\]{
  width: 112px;
}
.w-\\[118px\\]{
  width: 118px;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[124px\\]{
  width: 124px;
}
.w-\\[13\\%\\]{
  width: 13%;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[14rem\\]{
  width: 14rem;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[17\\%\\]{
  width: 17%;
}
.w-\\[18\\%\\]{
  width: 18%;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[19\\%\\]{
  width: 19%;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[27\\%\\]{
  width: 27%;
}
.w-\\[3\\%\\]{
  width: 3%;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[38px\\]{
  width: 38px;
}
.w-\\[4\\%\\]{
  width: 4%;
}
.w-\\[4\\.25rem\\]{
  width: 4.25rem;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[4\\.75rem\\]{
  width: 4.75rem;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[5\\.5rem\\]{
  width: 5.5rem;
}
.w-\\[6\\%\\]{
  width: 6%;
}
.w-\\[6\\.5px\\]{
  width: 6.5px;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[7\\.25rem\\]{
  width: 7.25rem;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[84px\\]{
  width: 84px;
}
.w-\\[9\\%\\]{
  width: 9%;
}
.w-\\[9rem\\]{
  width: 9rem;
}
.w-\\[calc\\(100\\%-1\\.5rem\\)\\]{
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(100\\%-2rem\\)\\]{
  width: calc(100% - 2rem);
}
.w-\\[calc\\(100vw-2rem\\)\\]{
  width: calc(100vw - 2rem);
}
.w-\\[calc\\(20\\%-0\\.3rem\\)\\]{
  width: calc(20% - 0.3rem);
}
.w-\\[calc\\(80\\%-1\\.6rem\\)\\]{
  width: calc(80% - 1.6rem);
}
.w-\\[min\\(20rem\\2c calc\\(100vw_-_1\\.5rem\\)\\)\\]{
  width: min(20rem, calc(100vw - 1.5rem));
}
.w-\\[min\\(92vw\\2c 380px\\)\\]{
  width: min(92vw, 380px);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[1\\.25rem\\]{
  min-width: 1.25rem;
}
.min-w-\\[1\\.5rem\\]{
  min-width: 1.5rem;
}
.min-w-\\[1000px\\]{
  min-width: 1000px;
}
.min-w-\\[1060px\\]{
  min-width: 1060px;
}
.min-w-\\[1080px\\]{
  min-width: 1080px;
}
.min-w-\\[10rem\\]{
  min-width: 10rem;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[110px\\]{
  min-width: 110px;
}
.min-w-\\[1120px\\]{
  min-width: 1120px;
}
.min-w-\\[1140px\\]{
  min-width: 1140px;
}
.min-w-\\[1180px\\]{
  min-width: 1180px;
}
.min-w-\\[11rem\\]{
  min-width: 11rem;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[1240px\\]{
  min-width: 1240px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[190px\\]{
  min-width: 190px;
}
.min-w-\\[1rem\\]{
  min-width: 1rem;
}
.min-w-\\[2\\.25rem\\]{
  min-width: 2.25rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[2rem\\]{
  min-width: 2rem;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[34px\\]{
  min-width: 34px;
}
.min-w-\\[3rem\\]{
  min-width: 3rem;
}
.min-w-\\[4\\.5rem\\]{
  min-width: 4.5rem;
}
.min-w-\\[40rem\\]{
  min-width: 40rem;
}
.min-w-\\[44rem\\]{
  min-width: 44rem;
}
.min-w-\\[5\\.5rem\\]{
  min-width: 5.5rem;
}
.min-w-\\[52rem\\]{
  min-width: 52rem;
}
.min-w-\\[560px\\]{
  min-width: 560px;
}
.min-w-\\[56rem\\]{
  min-width: 56rem;
}
.min-w-\\[60rem\\]{
  min-width: 60rem;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[64px\\]{
  min-width: 64px;
}
.min-w-\\[64rem\\]{
  min-width: 64rem;
}
.min-w-\\[680px\\]{
  min-width: 680px;
}
.min-w-\\[6rem\\]{
  min-width: 6rem;
}
.min-w-\\[7\\.5rem\\]{
  min-width: 7.5rem;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[760px\\]{
  min-width: 760px;
}
.min-w-\\[780px\\]{
  min-width: 780px;
}
.min-w-\\[8\\.5rem\\]{
  min-width: 8.5rem;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[820px\\]{
  min-width: 820px;
}
.min-w-\\[84px\\]{
  min-width: 84px;
}
.min-w-\\[860px\\]{
  min-width: 860px;
}
.min-w-\\[86px\\]{
  min-width: 86px;
}
.min-w-\\[880px\\]{
  min-width: 880px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[900px\\]{
  min-width: 900px;
}
.min-w-\\[920px\\]{
  min-width: 920px;
}
.min-w-\\[940px\\]{
  min-width: 940px;
}
.min-w-\\[960px\\]{
  min-width: 960px;
}
.min-w-\\[980px\\]{
  min-width: 980px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-full{
  min-width: 100%;
}
.max-w-0{
  max-width: 0px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[11rem\\]{
  max-width: 11rem;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[12rem\\]{
  max-width: 12rem;
}
.max-w-\\[130px\\]{
  max-width: 130px;
}
.max-w-\\[13rem\\]{
  max-width: 13rem;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[14rem\\]{
  max-width: 14rem;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[19\\.2rem\\]{
  max-width: 19.2rem;
}
.max-w-\\[190px\\]{
  max-width: 190px;
}
.max-w-\\[232px\\]{
  max-width: 232px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[514px\\]{
  max-width: 514px;
}
.max-w-\\[570px\\]{
  max-width: 570px;
}
.max-w-\\[720px\\]{
  max-width: 720px;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-\\[750px\\]{
  max-width: 750px;
}
.max-w-\\[76px\\]{
  max-width: 76px;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[80vw\\]{
  max-width: 80vw;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[9rem\\]{
  max-width: 9rem;
}
.max-w-\\[calc\\(100vw-16px\\)\\]{
  max-width: calc(100vw - 16px);
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[1\\.2\\]{
  flex: 1.2 1;
}
.flex-\\[1_1_3rem\\]{
  flex: 1 1 3rem;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-0{
  flex-basis: 0px;
}
.basis-32{
  flex-basis: 8rem;
}
.basis-\\[30\\%\\]{
  flex-basis: 30%;
}
.basis-full{
  flex-basis: 100%;
}
.table-fixed{
  table-layout: fixed;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-x-0{
  --tw-border-spacing-x: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-y-2{
  --tw-border-spacing-y: 0.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.auto-cols-\\[minmax\\(min-content\\2c 1fr\\)\\]{
  grid-auto-columns: minmax(min-content,1fr);
}
.auto-cols-fr{
  grid-auto-columns: minmax(0, 1fr);
}
.grid-flow-col{
  grid-auto-flow: column;
}
.auto-rows-fr{
  grid-auto-rows: minmax(0, 1fr);
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[6\\.5rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 6.5rem minmax(0,1fr);
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: auto minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: minmax(0,1fr) auto minmax(0,1fr);
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-x-1\\.5{
  column-gap: 0.375rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-2\\.5{
  row-gap: 0.625rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#EFEAE0\\] > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(239 234 224 / var(--tw-divide-opacity, 1));
}
.divide-emerald-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--bd-emerald-100, 209 250 229) / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--bd-slate-100, 241 245 249) / var(--tw-divide-opacity, 1));
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-divide-opacity, 1));
}
.divide-slate-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--bd-slate-50, 248 250 252) / var(--tw-divide-opacity, 1));
}
.divide-teal-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--bd-teal-100, 204 251 241) / var(--tw-divide-opacity, 1));
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.self-stretch{
  align-self: stretch;
}
.justify-self-start{
  justify-self: start;
}
.justify-self-end{
  justify-self: end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[13px\\]{
  border-radius: 13px;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-\\[2px\\]{
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.rounded-l-\\[5px\\]{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.rounded-l-md{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-r-\\[2px\\]{
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.rounded-r-\\[4px\\]{
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.rounded-r-\\[5px\\]{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.rounded-r-lg{
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}
.rounded-r-md{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-r-none{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-md{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-bl-sm{
  border-bottom-left-radius: calc(var(--radius) - 4px);
}
.rounded-br-sm{
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-amber-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--bd-amber-300, 252 211 77) / var(--tw-border-opacity, 1)) !important;
}
.\\!border-rose-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--bd-rose-300, 253 164 175) / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#25D366\\]\\/40{
  border-color: rgb(37 211 102 / 0.4);
}
.border-\\[\\#E4E4E4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFEAE0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(239 234 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFEAE0\\]\\/60{
  border-color: rgb(239 234 224 / 0.6);
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-100, 254 243 199) / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-200, 253 230 138) / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-300, 252 211 77) / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-400, 251 191 36) / var(--tw-border-opacity, 1));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-500, 245 158 11) / var(--tw-border-opacity, 1));
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-600, 217 119 6) / var(--tw-border-opacity, 1));
}
.border-amber-800{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-800, 146 64 14) / var(--tw-border-opacity, 1));
}
.border-black\\/\\[0\\.06\\]{
  border-color: rgb(0 0 0 / 0.06);
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-blue-100, 219 234 254) / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-blue-200, 191 219 254) / var(--tw-border-opacity, 1));
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-blue-300, 147 197 253) / var(--tw-border-opacity, 1));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-blue-500, 59 130 246) / var(--tw-border-opacity, 1));
}
.border-current{
  border-color: currentColor;
}
.border-cyan-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-100, 207 250 254) / var(--tw-border-opacity, 1));
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-200, 165 243 252) / var(--tw-border-opacity, 1));
}
.border-cyan-200\\/80{
  border-color: rgb(var(--bd-cyan-200, 165 243 252) / 0.8);
}
.border-cyan-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-300, 103 232 249) / var(--tw-border-opacity, 1));
}
.border-cyan-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-400, 34 211 238) / var(--tw-border-opacity, 1));
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-500, 6 182 212) / var(--tw-border-opacity, 1));
}
.border-cyan-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-cyan-600, 8 145 178) / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-100, 209 250 229) / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-200, 167 243 208) / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/80{
  border-color: rgb(var(--bd-emerald-200, 167 243 208) / 0.8);
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-300, 110 231 183) / var(--tw-border-opacity, 1));
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-400, 52 211 153) / var(--tw-border-opacity, 1));
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-500, 16 185 129) / var(--tw-border-opacity, 1));
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-600, 5 150 105) / var(--tw-border-opacity, 1));
}
.border-emerald-900{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-900, 6 78 59) / var(--tw-border-opacity, 1));
}
.border-fuchsia-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-fuchsia-300, 240 171 252) / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-gray-400, 156 163 175) / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-green-200, 187 247 208) / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-green-400, 74 222 128) / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-green-500, 34 197 94) / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-100, 224 231 255) / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-200, 199 210 254) / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/80{
  border-color: rgb(var(--bd-indigo-200, 199 210 254) / 0.8);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-300, 165 180 252) / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-400, 129 140 248) / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-500, 99 102 241) / var(--tw-border-opacity, 1));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-600, 79 70 229) / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-lime-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-lime-300, 190 242 100) / var(--tw-border-opacity, 1));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-100, 255 237 213) / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-200, 254 215 170) / var(--tw-border-opacity, 1));
}
.border-orange-200\\/80{
  border-color: rgb(var(--bd-orange-200, 254 215 170) / 0.8);
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-300, 253 186 116) / var(--tw-border-opacity, 1));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-400, 251 146 60) / var(--tw-border-opacity, 1));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-500, 249 115 22) / var(--tw-border-opacity, 1));
}
.border-orange-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-600, 234 88 12) / var(--tw-border-opacity, 1));
}
.border-orange-800{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-800, 154 52 18) / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-pink-200, 251 207 232) / var(--tw-border-opacity, 1));
}
.border-pink-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-pink-300, 249 168 212) / var(--tw-border-opacity, 1));
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-pink-500, 236 72 153) / var(--tw-border-opacity, 1));
}
.border-pink-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-pink-600, 219 39 119) / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-purple-200, 233 213 255) / var(--tw-border-opacity, 1));
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-purple-300, 216 180 254) / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-red-200, 254 202 202) / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-red-300, 252 165 165) / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-red-400, 248 113 113) / var(--tw-border-opacity, 1));
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-100, 255 228 230) / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-200, 254 205 211) / var(--tw-border-opacity, 1));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-300, 253 164 175) / var(--tw-border-opacity, 1));
}
.border-rose-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-400, 251 113 133) / var(--tw-border-opacity, 1));
}
.border-rose-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-500, 244 63 94) / var(--tw-border-opacity, 1));
}
.border-rose-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-600, 225 29 72) / var(--tw-border-opacity, 1));
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-100, 224 242 254) / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-200, 186 230 253) / var(--tw-border-opacity, 1));
}
.border-sky-200\\/80{
  border-color: rgb(var(--bd-sky-200, 186 230 253) / 0.8);
}
.border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-300, 125 211 252) / var(--tw-border-opacity, 1));
}
.border-sky-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-400, 56 189 248) / var(--tw-border-opacity, 1));
}
.border-sky-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-500, 14 165 233) / var(--tw-border-opacity, 1));
}
.border-sky-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-600, 2 132 199) / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-100, 241 245 249) / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
}
.border-slate-200\\/70{
  border-color: rgb(var(--bd-slate-200, 226 232 240) / 0.7);
}
.border-slate-200\\/80{
  border-color: rgb(var(--bd-slate-200, 226 232 240) / 0.8);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-300, 203 213 225) / var(--tw-border-opacity, 1));
}
.border-slate-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-400, 148 163 184) / var(--tw-border-opacity, 1));
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-50, 248 250 252) / var(--tw-border-opacity, 1));
}
.border-slate-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-500, 100 116 139) / var(--tw-border-opacity, 1));
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-600, 71 85 105) / var(--tw-border-opacity, 1));
}
.border-slate-600\\/90{
  border-color: rgb(var(--bd-slate-600, 71 85 105) / 0.9);
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-700, 51 65 85) / var(--tw-border-opacity, 1));
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-800, 30 41 59) / var(--tw-border-opacity, 1));
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-900, 15 23 42) / var(--tw-border-opacity, 1));
}
.border-teal-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-100, 204 251 241) / var(--tw-border-opacity, 1));
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-200, 153 246 228) / var(--tw-border-opacity, 1));
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-300, 94 234 212) / var(--tw-border-opacity, 1));
}
.border-teal-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-400, 45 212 191) / var(--tw-border-opacity, 1));
}
.border-teal-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-500, 20 184 166) / var(--tw-border-opacity, 1));
}
.border-teal-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-600, 13 148 136) / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-100, 237 233 254) / var(--tw-border-opacity, 1));
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-200, 221 214 254) / var(--tw-border-opacity, 1));
}
.border-violet-200\\/80{
  border-color: rgb(var(--bd-violet-200, 221 214 254) / 0.8);
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-300, 196 181 253) / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-400, 167 139 250) / var(--tw-border-opacity, 1));
}
.border-violet-500{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-500, 139 92 246) / var(--tw-border-opacity, 1));
}
.border-violet-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-600, 124 58 237) / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-yellow-200, 254 240 138) / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-yellow-300, 253 224 71) / var(--tw-border-opacity, 1));
}
.border-l-amber-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(var(--bd-amber-400, 251 191 36) / var(--tw-border-opacity, 1));
}
.border-l-rose-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(var(--bd-rose-500, 244 63 94) / var(--tw-border-opacity, 1));
}
.border-l-sky-300{
  --tw-border-opacity: 1;
  border-left-color: rgb(var(--bd-sky-300, 125 211 252) / var(--tw-border-opacity, 1));
}
.border-l-sky-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(var(--bd-sky-500, 14 165 233) / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-sky-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--bd-sky-600, 2 132 199) / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-amber-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--bg-amber-50, 255 251 235) / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-rose-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--bg-rose-50, 255 241 242) / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-sky-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-slate-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#25D366\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\]\\/10{
  background-color: rgb(37 211 102 / 0.1);
}
.bg-\\[\\#414141\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(65 65 65 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3EFE6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 239 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFCF8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dcf8c6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(220 248 198 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e5ddd5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 221 213 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff5c42\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 92 66 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-100, 254 243 199) / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/70{
  background-color: rgb(var(--bg-amber-100, 254 243 199) / 0.7);
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-200, 253 230 138) / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-400, 251 191 36) / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-50, 255 251 235) / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/40{
  background-color: rgb(var(--bg-amber-50, 255 251 235) / 0.4);
}
.bg-amber-50\\/50{
  background-color: rgb(var(--bg-amber-50, 255 251 235) / 0.5);
}
.bg-amber-50\\/60{
  background-color: rgb(var(--bg-amber-50, 255 251 235) / 0.6);
}
.bg-amber-50\\/70{
  background-color: rgb(var(--bg-amber-50, 255 251 235) / 0.7);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-500, 245 158 11) / var(--tw-bg-opacity, 1));
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-600, 217 119 6) / var(--tw-bg-opacity, 1));
}
.bg-amber-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-700, 180 83 9) / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/\\[0\\.06\\]{
  background-color: rgb(0 0 0 / 0.06);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-100, 219 234 254) / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-200, 191 219 254) / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-50, 239 246 255) / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/50{
  background-color: rgb(var(--bg-blue-50, 239 246 255) / 0.5);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-500, 59 130 246) / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-600, 37 99 235) / var(--tw-bg-opacity, 1));
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-700, 29 78 216) / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-100, 207 250 254) / var(--tw-bg-opacity, 1));
}
.bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-200, 165 243 252) / var(--tw-bg-opacity, 1));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-50, 236 254 255) / var(--tw-bg-opacity, 1));
}
.bg-cyan-50\\/50{
  background-color: rgb(var(--bg-cyan-50, 236 254 255) / 0.5);
}
.bg-cyan-50\\/70{
  background-color: rgb(var(--bg-cyan-50, 236 254 255) / 0.7);
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-500, 6 182 212) / var(--tw-bg-opacity, 1));
}
.bg-cyan-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-600, 8 145 178) / var(--tw-bg-opacity, 1));
}
.bg-cyan-600\\/10{
  background-color: rgb(var(--bg-cyan-600, 8 145 178) / 0.1);
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-100, 209 250 229) / var(--tw-bg-opacity, 1));
}
.bg-emerald-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-200, 167 243 208) / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-400, 52 211 153) / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / 0.4);
}
.bg-emerald-50\\/50{
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / 0.5);
}
.bg-emerald-50\\/60{
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / 0.6);
}
.bg-emerald-50\\/70{
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / 0.7);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-500, 16 185 129) / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-600, 5 150 105) / var(--tw-bg-opacity, 1));
}
.bg-emerald-600\\/10{
  background-color: rgb(var(--bg-emerald-600, 5 150 105) / 0.1);
}
.bg-emerald-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-700, 4 120 87) / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-fuchsia-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-fuchsia-100, 250 232 255) / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-fuchsia-50, 253 244 255) / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-gray-300, 209 213 219) / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-100, 220 252 231) / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-50, 240 253 244) / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/50{
  background-color: rgb(var(--bg-green-50, 240 253 244) / 0.5);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-500, 34 197 94) / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-600, 22 163 74) / var(--tw-bg-opacity, 1));
}
.bg-green-800{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-800, 22 101 52) / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-100, 224 231 255) / var(--tw-bg-opacity, 1));
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-400, 129 140 248) / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/40{
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / 0.4);
}
.bg-indigo-50\\/50{
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / 0.5);
}
.bg-indigo-50\\/60{
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / 0.6);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-500, 99 102 241) / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-600, 79 70 229) / var(--tw-bg-opacity, 1));
}
.bg-indigo-600\\/10{
  background-color: rgb(var(--bg-indigo-600, 79 70 229) / 0.1);
}
.bg-lime-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-lime-100, 236 252 203) / var(--tw-bg-opacity, 1));
}
.bg-lime-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-lime-200, 217 249 157) / var(--tw-bg-opacity, 1));
}
.bg-lime-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-lime-50, 247 254 231) / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-100, 255 237 213) / var(--tw-bg-opacity, 1));
}
.bg-orange-100\\/35{
  background-color: rgb(var(--bg-orange-100, 255 237 213) / 0.35);
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-200, 254 215 170) / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-400, 251 146 60) / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-50, 255 247 237) / var(--tw-bg-opacity, 1));
}
.bg-orange-50\\/40{
  background-color: rgb(var(--bg-orange-50, 255 247 237) / 0.4);
}
.bg-orange-50\\/60{
  background-color: rgb(var(--bg-orange-50, 255 247 237) / 0.6);
}
.bg-orange-50\\/70{
  background-color: rgb(var(--bg-orange-50, 255 247 237) / 0.7);
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-500, 249 115 22) / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10{
  background-color: rgb(var(--bg-orange-500, 249 115 22) / 0.1);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-600, 234 88 12) / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-pink-100, 252 231 243) / var(--tw-bg-opacity, 1));
}
.bg-pink-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-pink-200, 251 207 232) / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-pink-50, 253 242 248) / var(--tw-bg-opacity, 1));
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-pink-600, 219 39 119) / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-purple-100, 243 232 255) / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-purple-50, 250 245 255) / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/60{
  background-color: rgb(var(--bg-purple-50, 250 245 255) / 0.6);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-100, 254 226 226) / var(--tw-bg-opacity, 1));
}
.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-200, 254 202 202) / var(--tw-bg-opacity, 1));
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-300, 252 165 165) / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-50, 254 242 242) / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-500, 239 68 68) / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-600, 220 38 38) / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-100, 255 228 230) / var(--tw-bg-opacity, 1));
}
.bg-rose-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-400, 251 113 133) / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-50, 255 241 242) / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40{
  background-color: rgb(var(--bg-rose-50, 255 241 242) / 0.4);
}
.bg-rose-50\\/50{
  background-color: rgb(var(--bg-rose-50, 255 241 242) / 0.5);
}
.bg-rose-50\\/60{
  background-color: rgb(var(--bg-rose-50, 255 241 242) / 0.6);
}
.bg-rose-50\\/70{
  background-color: rgb(var(--bg-rose-50, 255 241 242) / 0.7);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-500, 244 63 94) / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-600, 225 29 72) / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-100, 224 242 254) / var(--tw-bg-opacity, 1));
}
.bg-sky-100\\/70{
  background-color: rgb(var(--bg-sky-100, 224 242 254) / 0.7);
}
.bg-sky-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-200, 186 230 253) / var(--tw-bg-opacity, 1));
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-400, 56 189 248) / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/40{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.4);
}
.bg-sky-50\\/50{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.5);
}
.bg-sky-50\\/60{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.6);
}
.bg-sky-50\\/70{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.7);
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-500, 14 165 233) / var(--tw-bg-opacity, 1));
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-600, 2 132 199) / var(--tw-bg-opacity, 1));
}
.bg-sky-600\\/10{
  background-color: rgb(var(--bg-sky-600, 2 132 199) / 0.1);
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/95{
  background-color: rgb(var(--bg-slate-100, 241 245 249) / 0.95);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-200, 226 232 240) / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/70{
  background-color: rgb(var(--bg-slate-200, 226 232 240) / 0.7);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-300, 203 213 225) / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-400, 148 163 184) / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/30{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.3);
}
.bg-slate-50\\/40{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.6);
}
.bg-slate-50\\/70{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.8);
}
.bg-slate-50\\/95{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.95);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-500, 100 116 139) / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/90{
  background-color: rgb(var(--bg-slate-500, 100 116 139) / 0.9);
}
.bg-slate-500\\/95{
  background-color: rgb(var(--bg-slate-500, 100 116 139) / 0.95);
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-600, 71 85 105) / var(--tw-bg-opacity, 1));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-700, 51 65 85) / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-800, 30 41 59) / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/90{
  background-color: rgb(var(--bg-slate-800, 30 41 59) / 0.9);
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-900, 15 23 42) / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/40{
  background-color: rgb(var(--bg-slate-900, 15 23 42) / 0.4);
}
.bg-slate-900\\/50{
  background-color: rgb(var(--bg-slate-900, 15 23 42) / 0.5);
}
.bg-slate-900\\/60{
  background-color: rgb(var(--bg-slate-900, 15 23 42) / 0.6);
}
.bg-slate-900\\/90{
  background-color: rgb(var(--bg-slate-900, 15 23 42) / 0.9);
}
.bg-slate-950\\/70{
  background-color: rgb(var(--bg-slate-950, 2 6 23) / 0.7);
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-100, 204 251 241) / var(--tw-bg-opacity, 1));
}
.bg-teal-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-400, 45 212 191) / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-50, 240 253 250) / var(--tw-bg-opacity, 1));
}
.bg-teal-50\\/50{
  background-color: rgb(var(--bg-teal-50, 240 253 250) / 0.5);
}
.bg-teal-50\\/60{
  background-color: rgb(var(--bg-teal-50, 240 253 250) / 0.6);
}
.bg-teal-50\\/70{
  background-color: rgb(var(--bg-teal-50, 240 253 250) / 0.7);
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-500, 20 184 166) / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-600, 13 148 136) / var(--tw-bg-opacity, 1));
}
.bg-teal-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-700, 15 118 110) / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-100, 237 233 254) / var(--tw-bg-opacity, 1));
}
.bg-violet-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-200, 221 214 254) / var(--tw-bg-opacity, 1));
}
.bg-violet-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-300, 196 181 253) / var(--tw-bg-opacity, 1));
}
.bg-violet-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-400, 167 139 250) / var(--tw-bg-opacity, 1));
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-50, 245 243 255) / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/40{
  background-color: rgb(var(--bg-violet-50, 245 243 255) / 0.4);
}
.bg-violet-50\\/50{
  background-color: rgb(var(--bg-violet-50, 245 243 255) / 0.5);
}
.bg-violet-50\\/60{
  background-color: rgb(var(--bg-violet-50, 245 243 255) / 0.6);
}
.bg-violet-50\\/70{
  background-color: rgb(var(--bg-violet-50, 245 243 255) / 0.7);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-500, 139 92 246) / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-600, 124 58 237) / var(--tw-bg-opacity, 1));
}
.bg-violet-600\\/10{
  background-color: rgb(var(--bg-violet-600, 124 58 237) / 0.1);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.1);
}
.bg-white\\/15{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.15);
}
.bg-white\\/20{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.2);
}
.bg-white\\/25{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.25);
}
.bg-white\\/60{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.6);
}
.bg-white\\/70{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.7);
}
.bg-white\\/80{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.8);
}
.bg-white\\/85{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.85);
}
.bg-white\\/90{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.9);
}
.bg-white\\/95{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-yellow-100, 254 249 195) / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-yellow-50, 254 252 232) / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-amber-500{
  --tw-gradient-from: rgb(var(--bg-amber-500, 245 158 11) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-amber-500, 245 158 11) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50{
  --tw-gradient-from: rgb(var(--bg-cyan-50, 236 254 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-cyan-50, 236 254 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50{
  --tw-gradient-from: rgb(var(--bg-emerald-50, 236 253 245) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-emerald-50, 236 253 245) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: rgb(var(--bg-emerald-500, 16 185 129) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-emerald-500, 16 185 129) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600{
  --tw-gradient-from: rgb(var(--bg-emerald-600, 5 150 105) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-emerald-600, 5 150 105) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: rgb(var(--bg-indigo-50, 238 242 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-indigo-50, 238 242 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: rgb(var(--bg-indigo-600, 79 70 229) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-indigo-600, 79 70 229) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50{
  --tw-gradient-from: rgb(var(--bg-orange-50, 255 247 237) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-orange-50, 255 247 237) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: rgb(var(--bg-orange-500, 249 115 22) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-orange-500, 249 115 22) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-400{
  --tw-gradient-from: rgb(var(--bg-sky-400, 56 189 248) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-sky-400, 56 189 248) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-50{
  --tw-gradient-from: rgb(var(--bg-sky-50, 240 249 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-sky-50, 240 249 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500{
  --tw-gradient-from: rgb(var(--bg-sky-500, 14 165 233) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-sky-500, 14 165 233) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500{
  --tw-gradient-from: rgb(var(--bg-teal-500, 20 184 166) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-teal-500, 20 184 166) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-400{
  --tw-gradient-from: rgb(var(--bg-violet-400, 167 139 250) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-violet-400, 167 139 250) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50{
  --tw-gradient-from: rgb(var(--bg-violet-50, 245 243 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--bg-violet-50, 245 243 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-cyan-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-cyan-50, 236 254 255) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-emerald-50, 236 253 245) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-indigo-50, 238 242 255) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-orange-50, 255 247 237) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-sky-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-sky-50, 240 249 255) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-50\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--bg-violet-50, 245 243 255) / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-500{
  --tw-gradient-to: rgb(var(--bg-amber-500, 245 158 11) / 1) var(--tw-gradient-to-position);
}
.to-emerald-400{
  --tw-gradient-to: rgb(var(--bg-emerald-400, 52 211 153) / 1) var(--tw-gradient-to-position);
}
.to-emerald-500{
  --tw-gradient-to: rgb(var(--bg-emerald-500, 16 185 129) / 1) var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: rgb(var(--bg-indigo-600, 79 70 229) / 1) var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: rgb(var(--bg-orange-500, 249 115 22) / 1) var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: rgb(var(--bg-teal-600, 13 148 136) / 1) var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: rgb(var(--bg-violet-600, 124 58 237) / 1) var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: rgb(var(--bg-white, 255 255 255) / 1) var(--tw-gradient-to-position);
}
.fill-\\[\\#F3EFE6\\]{
  fill: #F3EFE6;
}
.fill-amber-300{
  fill: #fcd34d;
}
.fill-amber-400{
  fill: #fbbf24;
}
.fill-current{
  fill: currentColor;
}
.fill-emerald-500{
  fill: #10b981;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.fill-rose-400{
  fill: #fb7185;
}
.fill-rose-500{
  fill: #f43f5e;
}
.fill-sky-600{
  fill: #0284c7;
}
.fill-slate-400{
  fill: #94a3b8;
}
.fill-slate-600{
  fill: #475569;
}
.fill-white{
  fill: #fff;
}
.stroke-sky-600{
  stroke: #0284c7;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[1px\\]{
  padding: 1px;
}
.p-\\[3px\\]{
  padding: 3px;
}
.p-\\[9px\\]{
  padding: 9px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[7px\\]{
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-\\[calc\\(1rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.pb-\\[calc\\(env\\(safe-area-inset-bottom\\)\\+1rem\\)\\]{
  padding-bottom: calc(env(safe-area-inset-bottom) + 1rem);
}
.pb-\\[env\\(safe-area-inset-bottom\\)\\]{
  padding-bottom: env(safe-area-inset-bottom);
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pr-\\[4\\.5rem\\]{
  padding-right: 4.5rem;
}
.pr-\\[7\\.5rem\\]{
  padding-right: 7.5rem;
}
.pr-\\[8\\.5rem\\]{
  padding-right: 8.5rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-11{
  padding-top: 2.75rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[\\'Inter\\'\\2c sans-serif\\]{
  font-family: 'Inter',sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.55rem\\]{
  font-size: 0.55rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[8\\.4px\\]{
  font-size: 8.4px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-3{
  line-height: .75rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.15\\]{
  line-height: 1.15;
}
.leading-\\[1\\.2\\]{
  line-height: 1.2;
}
.leading-\\[14px\\]{
  line-height: 14px;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.5em\\]{
  letter-spacing: 0.5em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#128C7E\\]{
  --tw-text-opacity: 1;
  color: rgb(18 140 126 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-300, 252 211 77) / var(--tw-text-opacity, 1));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-400, 251 191 36) / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-500, 245 158 11) / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-600, 217 119 6) / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-700, 180 83 9) / var(--tw-text-opacity, 1));
}
.text-amber-700\\/80{
  color: rgb(var(--tx-amber-700, 180 83 9) / 0.8);
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-800, 146 64 14) / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-900, 120 53 15) / var(--tw-text-opacity, 1));
}
.text-amber-900\\/80{
  color: rgb(var(--tx-amber-900, 120 53 15) / 0.8);
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-black\\/85{
  color: rgb(0 0 0 / 0.85);
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-blue-500, 59 130 246) / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-blue-600, 37 99 235) / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-blue-700, 29 78 216) / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-blue-800, 30 64 175) / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-cyan-600, 8 145 178) / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-cyan-700, 14 116 144) / var(--tw-text-opacity, 1));
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-cyan-800, 21 94 117) / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-200, 167 243 208) / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-500, 16 185 129) / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-600, 5 150 105) / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-700, 4 120 87) / var(--tw-text-opacity, 1));
}
.text-emerald-700\\/70{
  color: rgb(var(--tx-emerald-700, 4 120 87) / 0.7);
}
.text-emerald-700\\/80{
  color: rgb(var(--tx-emerald-700, 4 120 87) / 0.8);
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-800, 6 95 70) / var(--tw-text-opacity, 1));
}
.text-emerald-800\\/80{
  color: rgb(var(--tx-emerald-800, 6 95 70) / 0.8);
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-900, 6 78 59) / var(--tw-text-opacity, 1));
}
.text-emerald-900\\/80{
  color: rgb(var(--tx-emerald-900, 6 78 59) / 0.8);
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-fuchsia-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-fuchsia-700, 162 28 175) / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-gray-700, 55 65 81) / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-gray-900, 17 24 39) / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-green-500, 34 197 94) / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-green-600, 22 163 74) / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-green-700, 21 128 61) / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-green-800, 22 101 52) / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-400, 129 140 248) / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-500, 99 102 241) / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-600, 79 70 229) / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-700, 67 56 202) / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-800, 55 48 163) / var(--tw-text-opacity, 1));
}
.text-lime-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-lime-700, 77 124 15) / var(--tw-text-opacity, 1));
}
.text-lime-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-lime-800, 63 98 18) / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-400, 251 146 60) / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-500, 249 115 22) / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-600, 234 88 12) / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-700, 194 65 12) / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-800, 154 52 18) / var(--tw-text-opacity, 1));
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-900, 124 45 18) / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-pink-600, 219 39 119) / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-pink-700, 190 24 93) / var(--tw-text-opacity, 1));
}
.text-pink-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-pink-800, 157 23 77) / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-purple-600, 147 51 234) / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-purple-700, 126 34 206) / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-400, 248 113 113) / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-500, 239 68 68) / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-600, 220 38 38) / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-700, 185 28 28) / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-800, 153 27 27) / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-400, 251 113 133) / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-500, 244 63 94) / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-600, 225 29 72) / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-700, 190 18 60) / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-800, 159 18 57) / var(--tw-text-opacity, 1));
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-900, 136 19 55) / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-100{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-100, 224 242 254) / var(--tw-text-opacity, 1));
}
.text-sky-100\\/80{
  color: rgb(var(--tx-sky-100, 224 242 254) / 0.8);
}
.text-sky-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-400, 56 189 248) / var(--tw-text-opacity, 1));
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-500, 14 165 233) / var(--tw-text-opacity, 1));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-600, 2 132 199) / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-700, 3 105 161) / var(--tw-text-opacity, 1));
}
.text-sky-700\\/70{
  color: rgb(var(--tx-sky-700, 3 105 161) / 0.7);
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-800, 7 89 133) / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-900, 12 74 110) / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-200, 226 232 240) / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-300, 203 213 225) / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-500, 100 116 139) / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-600, 71 85 105) / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-700, 51 65 85) / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-800, 30 41 59) / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-900, 15 23 42) / var(--tw-text-opacity, 1));
}
.text-teal-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-400, 45 212 191) / var(--tw-text-opacity, 1));
}
.text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-500, 20 184 166) / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-600, 13 148 136) / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-700, 15 118 110) / var(--tw-text-opacity, 1));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-800, 17 94 89) / var(--tw-text-opacity, 1));
}
.text-teal-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-900, 19 78 74) / var(--tw-text-opacity, 1));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-500, 139 92 246) / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-600, 124 58 237) / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-700, 109 40 217) / var(--tw-text-opacity, 1));
}
.text-violet-700\\/70{
  color: rgb(var(--tx-violet-700, 109 40 217) / 0.7);
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-800, 91 33 182) / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-900, 76 29 149) / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-yellow-700, 161 98 7) / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-yellow-800, 133 77 14) / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.decoration-rose-300{
  text-decoration-color: #fda4af;
}
.decoration-slate-300{
  text-decoration-color: #cbd5e1;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-emerald-600{
  accent-color: #059669;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.accent-rose-600{
  accent-color: #e11d48;
}
.accent-sky-600{
  accent-color: #0284c7;
}
.accent-teal-600{
  accent-color: #0d9488;
}
.accent-violet-600{
  accent-color: #7c3aed;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.55\\]{
  opacity: 0.55;
}
.opacity-\\[0\\.64\\]{
  opacity: 0.64;
}
.opacity-\\[0\\.65\\]{
  opacity: 0.65;
}
.opacity-\\[0\\.85\\]{
  opacity: 0.85;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-2px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 -2px 10px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 -2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-2px_10px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 -2px 10px rgba(15,23,42,0.06);
  --tw-shadow-colored: 0 -2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_9999px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 0 0 9999px rgba(15,23,42,0.55);
  --tw-shadow-colored: 0 0 0 9999px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\2c 0_4px_14px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.07\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04),0 4px 14px rgba(15,23,42,0.07);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 2px rgba(16,24,40,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_0_rgb\\(0_0_0\\/0\\.055\\)\\2c 0_1px_2px_-1px_rgb\\(0_0_0\\/0\\.055\\)\\]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0/0.055),0 1px 2px -1px rgb(0 0 0/0.055);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 1px 3px rgba(15,23,42,0.1);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_4px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\2c 0_8px_20px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 2px 4px rgba(15,23,42,0.06),0 8px 20px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color), 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_-4px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.16\\)\\]{
  --tw-shadow: 0 4px 14px -4px rgba(16,24,40,0.16);
  --tw-shadow-colored: 0 4px 14px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_28px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.16\\)\\]{
  --tw-shadow: 0 8px 28px rgba(15,23,42,0.16);
  --tw-shadow-colored: 0 8px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(2\\2c 6\\2c 23\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 8px 30px rgb(2,6,23,0.04);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(2\\2c 6\\2c 23\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 8px 30px rgb(2,6,23,0.06);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-slate-900\\/20{
  --tw-shadow-color: rgb(15 23 42 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-amber-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-amber-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}
.ring-current{
  --tw-ring-color: currentColor;
}
.ring-emerald-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.ring-green-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-orange-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-rose-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity, 1));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-sky-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 242 254 / var(--tw-ring-opacity, 1));
}
.ring-sky-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-sky-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(125 211 252 / var(--tw-ring-opacity, 1));
}
.ring-sky-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
}
.ring-sky-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(2 132 199 / var(--tw-ring-opacity, 1));
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(100 116 139 / var(--tw-ring-opacity, 1));
}
.ring-slate-800{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 41 59 / var(--tw-ring-opacity, 1));
}
.ring-slate-900\\/5{
  --tw-ring-color: rgb(15 23 42 / 0.05);
}
.ring-teal-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 251 241 / var(--tw-ring-opacity, 1));
}
.ring-teal-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}
.ring-teal-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-violet-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/60{
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.ring-white\\/80{
  --tw-ring-color: rgb(255 255 255 / 0.8);
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-width\\2c margin\\2c opacity\\]{
  transition-property: max-width,margin,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.paused{
  animation-play-state: paused;
}
.\\[-ms-overflow-style\\:none\\]{
  -ms-overflow-style: none;
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(10\\.5rem\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(10.5rem,1fr));
}
.\\[hyphens\\:auto\\]{
  hyphens: auto;
}
.\\[justify-content\\:safe_center\\]{
  justify-content: safe center;
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}

body {
    margin: 0;
    font-family: "Inter", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: "JetBrains Mono", monospace;
}

/* No visible scrollbars anywhere in the OS — not down the side of the page, not
   inside a panel or a dialog. Scrolling itself is untouched: wheel, trackpad,
   touch, keyboard and drag all still work exactly as before; only the drawn
   track and thumb are gone. Both syntaxes are needed — Firefox reads
   scrollbar-width, Chrome and Safari only respond to ::-webkit-scrollbar. */

/* The one exception, opted into per element: a strip wider than the screen whose
   overflow a mouse user would otherwise never find (Operations > Branch's tab row).
   Outside the base layer so it beats the \`*\` rule above.

   Chrome 121+ draws its own native bar (grey, with arrow buttons) whenever
   scrollbar-width / scrollbar-color are set, and then ignores ::-webkit-scrollbar.
   So those two go to Firefox alone, and Chrome/Safari get the styled pseudo-elements
   in the theme's sky. */
.show-scrollbar {
    scrollbar-width: auto;
    scrollbar-color: auto;
}

@supports not selector(::-webkit-scrollbar) {
    .show-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #7dd3fc transparent;
    }
}

.show-scrollbar::-webkit-scrollbar {
    display: block;
    height: 5px;
}

.show-scrollbar::-webkit-scrollbar-button {
    display: none;
}

.show-scrollbar::-webkit-scrollbar-thumb {
    background: #bae6fd;
    border-radius: 9999px;
}

.show-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #38bdf8;
}

.show-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    margin: 0 8px;
}

/* A tab's notification badge (Accountant Manage), cycling round the RGB spectrum. A
   hue-rotate filter on the badge's wrapper, so the ping ring and the core turn together
   while white -- the count and the ring round the badge -- stays white, and the rotation
   holds lightness, so the count reads as well on green or blue as it does on red. The
   badge only; the tab under it keeps its own colour. Stands still in its base colour for
   a desk set to reduce motion. */
@keyframes rgb-badge-cycle {
    from {
        filter: hue-rotate(0deg);
    }
    to {
        filter: hue-rotate(360deg);
    }
}

.rgb-badge {
    animation: rgb-badge-cycle 3s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
    .rgb-badge {
        animation: none;
    }
}

/* Branch Admin > Consultation: the Overview tab of a patient at Consultation Visit or Fee Collected is drawn flat --
   no borders, 2px corners, and its buttons (View Details, Receipt) carry no
   icon. Round things (the step numbers and ticks) stay round. */
.fee-flat,
.fee-flat * {
  border-style: none !important;
}
.fee-flat [class*="rounded"]:not(.rounded-full),
.fee-flat button:not(.rounded-full) {
  border-radius: 2px !important;
}
.fee-flat [data-testid="cons-case-record-open"] > span.ml-auto svg,
.fee-flat [data-testid^="cons-fee-receipt"] svg {
  display: none !important;
}
/* ...and View Details is filled in its own colour, at 75% (set
   in the JSX). */
.fee-flat [data-testid="cons-case-record-view"] {
  background-color: #0284c7 !important; /* sky-600 */
  color: #fff !important;
  opacity: 0.75;
}
/* ...and every button down the right-hand side casts a shadow under its bottom edge only:
   the negative spread pulls it in from the sides. */
.fee-flat [data-testid="cons-case-record-view"],
.fee-flat [data-testid^="cons-fee-receipt"],
.fee-flat [data-testid^="cons-fee-act-"] {
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.7) !important;
}
/* ...and its buttons down the right-hand side -- View Details, every Receipt and
   Collect -- are one size and end on one edge: the fee rows take the same 16px
   inset the section headings have. */
.fee-flat [data-testid^="cons-fee-step-"] {
  padding-right: 16px !important;
}
.fee-flat [data-testid="cons-case-record-view"],
.fee-flat [data-testid^="cons-fee-receipt"],
.fee-flat [data-testid^="cons-fee-act-"] {
  width: 104px !important;
  min-width: 104px !important;
  height: 32px !important;
  padding: 0 8px !important;
  justify-content: center !important;
  font-size: 12px !important;
}
@media (min-width: 640px) {
  .fee-flat [data-testid="cons-case-record-view"],
  .fee-flat [data-testid^="cons-fee-receipt"],
  .fee-flat [data-testid^="cons-fee-act-"] {
    width: 130px !important;
    min-width: 130px !important;
  }
}
/* Fee Collected's buttons (.fee-soft, set in the JSX), drawn the same way on Consultation
   Visit, Physio Assign and the popup opened from the Rehab, Diet Consultation and Diet Chart
   pills: no button on the Overview is filled or casts a shadow -- each is its words and icon
   in colour on the white of its row, with 2px corners. The footer's Assign Physio, Mark Online
   and Add Due (and Collect Online Payment beside them) share one pastel violet, as do the
   Treatment Fee row's Mark Online and Physio Assign's Assign / Reassign Physio. Diet's buttons
   read in orange, Rehab's in cyan. A light tint shows on hover. The
   buttons alone take a 1px gray border; the rest of the Overview keeps its own borders, and
   the tab rows are left as they are. */
.fee-soft [data-testid="cons-case-record-view"],
.fee-soft [data-testid^="cons-fee-receipt"],
.fee-soft [data-testid^="cons-fee-act-"],
.fee-soft :is([data-testid^="cons-fee-inspect-treatment"], [data-testid="cons-fee-inspect-extra"]),
.fee-soft [data-testid^="cons-prebook-use-"],
.fee-soft [data-testid="cons-fee-mark-online"],
.fee-soft [data-testid="cons-open-physio-assign-from-fee-collected"],
.fee-soft [data-testid="cons-mark-online-menu"],
.fee-soft [data-testid="cons-open-add-due"],
.fee-soft [data-testid="cons-collect-online"],
.fee-soft [data-testid="cons-open-physio-assign"],
.fee-soft [data-testid="cons-reassign-physio"],
.fee-soft [data-testid="cons-physio-assign-collect-balance"],
.fee-soft [data-testid^="cons-diet-detail-"],
.fee-soft [data-testid="cons-open-diet-assign"],
.fee-soft [data-testid^="cons-rehab-detail-"],
.fee-soft [data-testid="cons-open-rehab-fee"] {
  background-color: transparent !important;
  box-shadow: none !important;
  border: 1px solid #d1d5db !important; /* gray-300 */
  border-radius: 2px !important;
}
.fee-soft [data-testid="cons-case-record-view"]:hover,
.fee-soft [data-testid^="cons-fee-receipt"]:hover,
.fee-soft [data-testid^="cons-fee-act-"]:hover,
.fee-soft [data-testid^="cons-prebook-use-"]:hover,
.fee-soft [data-testid="cons-physio-assign-collect-balance"]:hover {
  background-color: #f1f5f9 !important; /* slate-100 */
}
.fee-soft [data-testid="cons-fee-mark-online"],
.fee-soft [data-testid="cons-open-physio-assign-from-fee-collected"],
.fee-soft [data-testid="cons-mark-online-menu"],
.fee-soft [data-testid="cons-open-add-due"],
.fee-soft [data-testid="cons-collect-online"],
.fee-soft [data-testid="cons-open-physio-assign"],
.fee-soft [data-testid="cons-reassign-physio"] {
  color: #8b5cf6 !important; /* violet-500 */
}
.fee-soft [data-testid="cons-fee-mark-online"]:hover,
.fee-soft [data-testid="cons-open-physio-assign-from-fee-collected"]:hover,
.fee-soft [data-testid="cons-mark-online-menu"]:hover,
.fee-soft [data-testid="cons-open-add-due"]:hover,
.fee-soft [data-testid="cons-collect-online"]:hover,
.fee-soft [data-testid="cons-open-physio-assign"]:hover,
.fee-soft [data-testid="cons-reassign-physio"]:hover {
  background-color: #f5f3ff !important; /* violet-50 */
  color: #7c3aed !important; /* violet-600 */
}
.fee-soft [data-testid^="cons-diet-detail-"],
.fee-soft [data-testid="cons-open-diet-assign"] {
  color: #ea580c !important; /* orange-600 */
}
.fee-soft [data-testid^="cons-diet-detail-"]:hover,
.fee-soft [data-testid="cons-open-diet-assign"]:hover {
  background-color: #fff7ed !important; /* orange-50 */
  color: #c2410c !important; /* orange-700 */
}
.fee-soft [data-testid^="cons-rehab-detail-"],
.fee-soft [data-testid="cons-open-rehab-fee"] {
  color: #0891b2 !important; /* cyan-600 */
}
.fee-soft [data-testid^="cons-rehab-detail-"]:hover,
.fee-soft [data-testid="cons-open-rehab-fee"]:hover {
  background-color: #ecfeff !important; /* cyan-50 */
  color: #0e7490 !important; /* cyan-700 */
}
/* Physio Assign's Collect Balance reads in the amber of the box it sits in, rose once overdue. */
.fee-soft [data-testid="cons-physio-assign-collect-balance"] {
  color: #b45309 !important; /* amber-700 */
}
.fee-soft [data-testid="cons-physio-assign-collect-balance"].bg-rose-600 {
  color: #e11d48 !important; /* rose-600 */
}
/* View Details and the next fee's Collect keep their sky as the colour of their words; the
   other Collects read in slate, and Receipt keeps its emerald (set in the JSX). */
.fee-soft [data-testid^="cons-fee-act-"] {
  color: #334155 !important; /* slate-700 */
}
.fee-soft [data-testid="cons-case-record-view"],
.fee-soft [data-testid^="cons-fee-act-"].bg-sky-600 {
  color: #0284c7 !important; /* sky-600 */
  opacity: 1;
}
.fee-soft [data-testid^="cons-prebook-use-"] {
  color: #0f766e !important; /* teal-700 */
}
/* Inspect is as wide as its word, under the Treatment Fee's name. */
.fee-soft :is([data-testid^="cons-fee-inspect-treatment"], [data-testid="cons-fee-inspect-extra"]) {
  width: auto !important;
  padding: 0 6px !important;
  justify-content: flex-start !important;
  color: #0284c7 !important; /* sky-600 */
  opacity: 1;
}
.fee-soft :is([data-testid^="cons-fee-inspect-treatment"], [data-testid="cons-fee-inspect-extra"]):hover {
  text-decoration: underline;
}
/* ...and on Fee Collected alone (.fee-collected), the rows of fees already in sit on white
   like the rest, not on a green tint. */
.fee-collected [data-testid^="cons-fee-step-"] {
  background-color: #fff !important;
}
.file\\:mr-2::file-selector-button{
  margin-right: 0.5rem;
}
.file\\:rounded-md::file-selector-button{
  border-radius: calc(var(--radius) - 2px);
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-orange-100::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-100, 255 237 213) / var(--tw-bg-opacity, 1));
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:px-2::file-selector-button{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.file\\:py-1::file-selector-button{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:text-\\[11px\\]::file-selector-button{
  font-size: 11px;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:font-semibold::file-selector-button{
  font-weight: 600;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.file\\:text-orange-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-700, 194 65 12) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-slate-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-300, 203 213 225) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.first\\:pt-0:first-child{
  padding-top: 0px;
}
.last\\:mb-0:last-child{
  margin-bottom: 0px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:pb-0:last-child{
  padding-bottom: 0px;
}
.empty\\:hidden:empty{
  display: none;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-sky-400:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-400, 56 189 248) / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-sky-300:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(125 211 252 / var(--tw-ring-opacity, 1));
}
.hover\\:border-amber-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-300, 252 211 77) / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-300, 110 231 183) / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-400, 52 211 153) / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-500, 16 185 129) / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-300, 165 180 252) / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-300, 253 186 116) / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-200, 254 205 211) / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-400, 251 113 133) / var(--tw-border-opacity, 1));
}
.hover\\:border-sky-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-200, 186 230 253) / var(--tw-border-opacity, 1));
}
.hover\\:border-sky-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-300, 125 211 252) / var(--tw-border-opacity, 1));
}
.hover\\:border-sky-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-400, 56 189 248) / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-300, 203 213 225) / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-400, 148 163 184) / var(--tw-border-opacity, 1));
}
.hover\\:border-teal-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-300, 94 234 212) / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#1da851\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 168 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#EFEAE0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 234 224 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F3EFE6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 239 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FDFCF8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 252 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-100, 254 243 199) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-50, 255 251 235) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50\\/50:hover{
  background-color: rgb(var(--bg-amber-50, 255 251 235) / 0.5);
}
.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-500, 245 158 11) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-600, 217 119 6) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-700, 180 83 9) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-700, 29 78 216) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-blue-800, 30 64 175) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-cyan-700, 14 116 144) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-100, 209 250 229) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50\\/50:hover{
  background-color: rgb(var(--bg-emerald-50, 236 253 245) / 0.5);
}
.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-600, 5 150 105) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-700, 4 120 87) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-700, 21 128 61) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-900, 20 83 45) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-100, 224 231 255) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-200, 199 210 254) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50\\/50:hover{
  background-color: rgb(var(--bg-indigo-50, 238 242 255) / 0.5);
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-indigo-700, 67 56 202) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-100, 255 237 213) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-200, 254 215 170) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-50, 255 247 237) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-600, 234 88 12) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-orange-700, 194 65 12) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-50, 254 242 242) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-red-700, 185 28 28) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-100, 255 228 230) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-50, 255 241 242) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-700, 190 18 60) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-sky-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-100, 224 242 254) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-300, 125 211 252) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-50\\/40:hover{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.4);
}
.hover\\:bg-sky-50\\/50:hover{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.5);
}
.hover\\:bg-sky-50\\/60:hover{
  background-color: rgb(var(--bg-sky-50, 240 249 255) / 0.6);
}
.hover\\:bg-sky-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-600, 2 132 199) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-700, 3 105 161) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100\\/70:hover{
  background-color: rgb(var(--bg-slate-100, 241 245 249) / 0.7);
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-200, 226 232 240) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/50:hover{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.5);
}
.hover\\:bg-slate-50\\/60:hover{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.6);
}
.hover\\:bg-slate-50\\/70:hover{
  background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.7);
}
.hover\\:bg-slate-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-600, 71 85 105) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-700, 51 65 85) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-800, 30 41 59) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-900, 15 23 42) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-100, 204 251 241) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-50, 240 253 250) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-700, 15 118 110) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-teal-800, 17 94 89) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-transparent:hover{
  background-color: transparent;
}
.hover\\:bg-violet-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-100, 237 233 254) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-400, 167 139 250) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-50, 245 243 255) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-50\\/60:hover{
  background-color: rgb(var(--bg-violet-50, 245 243 255) / 0.6);
}
.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-violet-700, 109 40 217) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.1);
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.15);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.2);
}
.hover\\:bg-white\\/25:hover{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.25);
}
.hover\\:bg-white\\/60:hover{
  background-color: rgb(var(--bg-white, 255 255 255) / 0.6);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-300:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-300, 252 211 77) / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-400:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-400, 251 191 36) / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-600, 217 119 6) / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-900:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-900, 120 53 15) / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-blue-700, 29 78 216) / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-600, 5 150 105) / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-700, 4 120 87) / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-emerald-800, 6 95 70) / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-indigo-600, 79 70 229) / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-orange-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-orange-800, 154 52 18) / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-400, 248 113 113) / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-500, 239 68 68) / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-600, 220 38 38) / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-700, 185 28 28) / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-400:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-400, 251 113 133) / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-500:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-500, 244 63 94) / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-600, 225 29 72) / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-700, 190 18 60) / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-800, 159 18 57) / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-600, 2 132 199) / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-700, 3 105 161) / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-800, 7 89 133) / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-900:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-900, 12 74 110) / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-500:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-500, 100 116 139) / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-600, 71 85 105) / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-700, 51 65 85) / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-800, 30 41 59) / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-900, 15 23 42) / var(--tw-text-opacity, 1));
}
.hover\\:text-teal-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-600, 13 148 136) / var(--tw-text-opacity, 1));
}
.hover\\:text-teal-900:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-teal-900, 19 78 74) / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-600, 124 58 237) / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-700, 109 40 217) / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-800, 91 33 182) / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-900:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-violet-900, 76 29 149) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:shadow:hover{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_2px_4px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.05\\)\\2c 0_6px_16px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]:hover{
  --tw-shadow: 0 2px 4px rgba(15,23,42,0.05),0 6px 16px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color), 0 6px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_2px_4px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.05\\)\\2c 0_8px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.10\\)\\]:hover{
  --tw-shadow: 0 2px 4px rgba(15,23,42,0.05),0 8px 24px rgba(15,23,42,0.10);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color), 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:brightness-95:hover{
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-\\[0\\.97\\]:hover{
  --tw-brightness: brightness(0.97);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-amber-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-400, 251 191 36) / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-400, 52 211 153) / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-emerald-500, 16 185 129) / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-indigo-400, 129 140 248) / var(--tw-border-opacity, 1));
}
.focus\\:border-orange-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-orange-400, 251 146 60) / var(--tw-border-opacity, 1));
}
.focus\\:border-red-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-red-400, 248 113 113) / var(--tw-border-opacity, 1));
}
.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-red-500, 239 68 68) / var(--tw-border-opacity, 1));
}
.focus\\:border-rose-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-rose-400, 251 113 133) / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-300, 125 211 252) / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-400, 56 189 248) / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-500, 14 165 233) / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-400, 148 163 184) / var(--tw-border-opacity, 1));
}
.focus\\:border-teal-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-400, 45 212 191) / var(--tw-border-opacity, 1));
}
.focus\\:border-violet-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-violet-400, 167 139 250) / var(--tw-border-opacity, 1));
}
.focus\\:bg-\\[\\#F3EFE6\\]:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(243 239 230 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:bg-sky-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.focus\\:bg-slate-900\\/\\[0\\.06\\]:focus{
  background-color: rgb(var(--bg-slate-900, 15 23 42) / 0.06);
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:text-sky-700:focus{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-700, 3 105 161) / var(--tw-text-opacity, 1));
}
.focus\\:text-slate-800:focus{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-800, 30 41 59) / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-amber-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-amber-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(110 231 183 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-rose-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 242 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(125 211 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-slate-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(148 163 184 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-teal-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-teal-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-violet-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:border-teal-400:focus-visible{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-400, 45 212 191) / var(--tw-border-opacity, 1));
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-emerald-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-indigo-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-sky-200:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-sky-400:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-sky-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.active\\:bg-\\[\\#25D366\\]\\/20:active{
  background-color: rgb(37 211 102 / 0.2);
}
.active\\:bg-emerald-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-100, 209 250 229) / var(--tw-bg-opacity, 1));
}
.active\\:bg-green-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-green-50, 240 253 244) / var(--tw-bg-opacity, 1));
}
.active\\:bg-rose-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-50, 255 241 242) / var(--tw-bg-opacity, 1));
}
.active\\:bg-sky-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-100, 224 242 254) / var(--tw-bg-opacity, 1));
}
.active\\:bg-sky-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.active\\:bg-sky-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-700, 3 105 161) / var(--tw-bg-opacity, 1));
}
.active\\:bg-slate-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.active\\:bg-slate-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
}
.active\\:text-rose-500:active{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-rose-500, 244 63 94) / var(--tw-text-opacity, 1));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-slate-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-300, 203 213 225) / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
}
.disabled\\:text-slate-300:disabled{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-300, 203 213 225) / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-500, 100 116 139) / var(--tw-text-opacity, 1));
}
.disabled\\:no-underline:disabled{
  text-decoration-line: none;
}
.disabled\\:opacity-100:disabled{
  opacity: 1;
}
.disabled\\:opacity-25:disabled{
  opacity: 0.25;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-90:disabled{
  opacity: 0.9;
}
.disabled\\:hover\\:border-slate-200:hover:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
}
.disabled\\:hover\\:bg-white:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
}
.group:focus-within .group-focus-within\\:text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-500, 14 165 233) / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-300, 125 211 252) / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-slate-300, 203 213 225) / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-100, 224 242 254) / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:active .group-active\\:rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toast .group-\\[\\.toast\\]\\:\\!border-red-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--bd-red-400, 248 113 113) / var(--tw-border-opacity, 1)) !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:\\!bg-red-500\\/10{
  background-color: rgb(var(--bg-red-500, 239 68 68) / 0.1) !important;
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-300, 252 165 165) / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:\\!text-red-600{
  --tw-text-opacity: 1 !important;
  color: rgb(var(--tx-red-600, 220 38 38) / var(--tw-text-opacity, 1)) !important;
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toast .group-\\[\\.toast\\]\\:\\!opacity-100{
  opacity: 1 !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.toast .group-\\[\\.toast\\]\\:hover\\:\\!bg-red-500\\/20:hover{
  background-color: rgb(var(--bg-red-500, 239 68 68) / 0.2) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-red-50, 254 242 242) / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:empty ~ .peer-empty\\:mt-0{
  margin-top: 0px;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[state\\=checked\\]\\:border-sky-600[data-state="checked"]{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-sky-600, 2 132 199) / var(--tw-border-opacity, 1));
}
.data-\\[state\\=open\\]\\:border-amber-300[data-state="open"]{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-amber-300, 252 211 77) / var(--tw-border-opacity, 1));
}
.data-\\[state\\=open\\]\\:border-teal-400[data-state="open"]{
  --tw-border-opacity: 1;
  border-color: rgb(var(--bd-teal-400, 45 212 191) / var(--tw-border-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-amber-100[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-amber-100, 254 243 199) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-emerald-500[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-500, 16 185 129) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-emerald-600[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-emerald-600, 5 150 105) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=checked\\]\\:bg-sky-600[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-600, 2 132 199) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=open\\]\\:bg-sky-50[data-state="open"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[state\\=unchecked\\]\\:bg-rose-500[data-state="unchecked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--bg-rose-500, 244 63 94) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:font-semibold[data-state="checked"]{
  font-weight: 600;
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[placeholder\\]\\:text-slate-400[data-placeholder]{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-amber-800[data-state="checked"]{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-amber-800, 146 64 14) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[state\\=open\\]\\:text-sky-700[data-state="open"]{
  --tw-text-opacity: 1;
  color: rgb(var(--tx-sky-700, 3 105 161) / var(--tw-text-opacity, 1));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=open\\]\\:ring-1[data-state="open"]{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.data-\\[state\\=open\\]\\:ring-teal-400[data-state="open"]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity, 1));
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@supports (height:100dvh){

  .supports-\\[height\\:100dvh\\]\\:max-h-\\[calc\\(100dvh-2rem\\)\\]{
    max-height: calc(100dvh - 2rem);
  }

  .supports-\\[height\\:100dvh\\]\\:min-h-\\[100dvh\\]{
    min-height: 100dvh;
  }
}
@supports (backdrop-filter: var(--tw)){

  .supports-\\[backdrop-filter\\]\\:bg-slate-100\\/80{
    background-color: rgb(var(--bg-slate-100, 241 245 249) / 0.8);
  }

  .supports-\\[backdrop-filter\\]\\:bg-slate-500\\/85{
    background-color: rgb(var(--bg-slate-500, 100 116 139) / 0.85);
  }

  .supports-\\[backdrop-filter\\]\\:bg-white\\/80{
    background-color: rgb(var(--bg-white, 255 255 255) / 0.8);
  }
}
@media (prefers-reduced-motion: no-preference){

  @keyframes nudge-left{

    0%, 40%, 100%{
      transform: translateX(0);
    }

    20%{
      transform: translateX(-5px);
    }
  }

  .motion-safe\\:animate-\\[nudge-left_1s_ease-in-out_infinite\\]{
    animation: nudge-left 1s ease-in-out infinite;
  }

  @keyframes bounce{

    0%, 100%{
      transform: translateY(-25%);
      animation-timing-function: cubic-bezier(0.8,0,1,1);
    }

    50%{
      transform: none;
      animation-timing-function: cubic-bezier(0,0,0.2,1);
    }
  }

  .motion-safe\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  @keyframes dot-pop{

    0%{
      transform: scale(0);
    }

    8%{
      transform: scale(1.35);
    }

    14%, 100%{
      transform: scale(1);
    }
  }

  .motion-safe\\:animate-dot-pop{
    animation: dot-pop 3s ease-out infinite;
  }

  @keyframes nudge-left{

    0%, 40%, 100%{
      transform: translateX(0);
    }

    20%{
      transform: translateX(-5px);
    }
  }

  .motion-safe\\:animate-nudge-left{
    animation: nudge-left 1.5s ease-in-out infinite;
  }

  @keyframes nudge-right{

    0%, 40%, 100%{
      transform: translateX(0);
    }

    20%{
      transform: translateX(4px);
    }
  }

  .motion-safe\\:animate-nudge-right{
    animation: nudge-right 1.5s ease-in-out infinite;
  }

  @keyframes ping{

    75%, 100%{
      transform: scale(2);
      opacity: 0;
    }
  }

  .motion-safe\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .motion-safe\\:duration-300{
    transition-duration: 300ms;
  }

  .motion-safe\\:animate-in{
    animation-name: enter;
    animation-duration: 150ms;
    --tw-enter-opacity: initial;
    --tw-enter-scale: initial;
    --tw-enter-rotate: initial;
    --tw-enter-translate-x: initial;
    --tw-enter-translate-y: initial;
  }

  .motion-safe\\:zoom-in-50{
    --tw-enter-scale: .5;
  }

  .motion-safe\\:duration-300{
    animation-duration: 300ms;
  }
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media not all and (min-width: 768px){

  .max-md\\:hidden{
    display: none;
  }

  .max-md\\:scale-90{
    --tw-scale-x: .9;
    --tw-scale-y: .9;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-md\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .max-md\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .max-md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .max-md\\:overflow-hidden{
    overflow: hidden;
  }

  .max-md\\:rounded-none{
    border-radius: 0px;
  }

  .max-md\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .max-md\\:border{
    border-width: 1px;
  }

  .max-md\\:border-0{
    border-width: 0px;
  }

  .max-md\\:border-b{
    border-bottom-width: 1px;
  }

  .max-md\\:border-slate-100{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-slate-100, 241 245 249) / var(--tw-border-opacity, 1));
  }

  .max-md\\:border-slate-200{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
  }

  .max-md\\:bg-slate-50\\/60{
    background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.6);
  }

  .max-md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
  }

  .max-md\\:p-3{
    padding: 0.75rem;
  }

  .max-md\\:text-slate-700{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-700, 51 65 85) / var(--tw-text-opacity, 1));
  }

  .max-md\\:\\[zoom\\:0\\.8\\]{
    zoom: 0.8;
  }
}
@media not all and (min-width: 640px){

  .max-sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .max-sm\\:inline-flex{
    display: inline-flex;
  }

  .max-sm\\:grid{
    display: grid;
  }

  .max-sm\\:hidden{
    display: none;
  }

  .max-sm\\:h-3\\.5{
    height: 0.875rem;
  }

  .max-sm\\:h-8{
    height: 2rem;
  }

  .max-sm\\:h-9{
    height: 2.25rem;
  }

  .max-sm\\:max-h-\\[90\\%\\]{
    max-height: 90%;
  }

  .max-sm\\:w-3\\.5{
    width: 0.875rem;
  }

  .max-sm\\:w-8{
    width: 2rem;
  }

  .max-sm\\:w-\\[90\\%\\]{
    width: 90%;
  }

  .max-sm\\:w-full{
    width: 100%;
  }

  .max-sm\\:min-w-0{
    min-width: 0px;
  }

  .max-sm\\:flex-1{
    flex: 1 1;
  }

  .max-sm\\:shrink{
    flex-shrink: 1;
  }

  .max-sm\\:shrink-0{
    flex-shrink: 0;
  }

  .max-sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .max-sm\\:flex-col{
    flex-direction: column;
  }

  .max-sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .max-sm\\:items-stretch{
    align-items: stretch;
  }

  .max-sm\\:justify-center{
    justify-content: center;
  }

  .max-sm\\:justify-between{
    justify-content: space-between;
  }

  .max-sm\\:gap-x-3{
    column-gap: 0.75rem;
  }

  .max-sm\\:gap-y-2{
    row-gap: 0.5rem;
  }

  .max-sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .max-sm\\:p-0{
    padding: 0px;
  }

  .max-sm\\:p-3{
    padding: 0.75rem;
  }

  .max-sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .max-sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .max-sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .max-sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .max-sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-sm\\:empty\\:hidden:empty{
    display: none;
  }
}
@media (max-width: 374px){

  .max-\\[374px\\]\\:gap-0\\.5{
    gap: 0.125rem;
  }

  .max-\\[374px\\]\\:text-\\[9px\\]{
    font-size: 9px;
  }
}
@media (min-width: 640px){

  .sm\\:-right-6{
    right: -1.5rem;
  }

  .sm\\:-top-6{
    top: -1.5rem;
  }

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:bottom-4{
    bottom: 1rem;
  }

  .sm\\:left-0{
    left: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:right-10{
    right: 2.5rem;
  }

  .sm\\:right-3\\.5{
    right: 0.875rem;
  }

  .sm\\:top-3\\.5{
    top: 0.875rem;
  }

  .sm\\:top-\\[88px\\]{
    top: 88px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:order-none{
    order: 0;
  }

  .sm\\:col-auto{
    grid-column: auto;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:m-0{
    margin: 0px;
  }

  .sm\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:ml-0{
    margin-left: 0px;
  }

  .sm\\:ml-2{
    margin-left: 0.5rem;
  }

  .sm\\:ml-4{
    margin-left: 1rem;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mr-0{
    margin-right: 0px;
  }

  .sm\\:mr-1{
    margin-right: 0.25rem;
  }

  .sm\\:mr-1\\.5{
    margin-right: 0.375rem;
  }

  .sm\\:mr-2{
    margin-right: 0.5rem;
  }

  .sm\\:mr-\\[30px\\]{
    margin-right: 30px;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-0\\.5{
    margin-top: 0.125rem;
  }

  .sm\\:mt-1{
    margin-top: 0.25rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:line-clamp-2{
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:contents{
    display: contents;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-3\\.5{
    height: 0.875rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-48{
    height: 12rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-56{
    height: 14rem;
  }

  .sm\\:h-7{
    height: 1.75rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:h-\\[450px\\]{
    height: 450px;
  }

  .sm\\:h-\\[550px\\]{
    height: 550px;
  }

  .sm\\:h-\\[84vh\\]{
    height: 84vh;
  }

  .sm\\:h-\\[min\\(610px\\2c calc\\(100dvh-1rem\\)\\)\\]{
    height: min(610px, calc(100dvh - 1rem));
  }

  .sm\\:max-h-\\[530px\\]{
    max-height: 530px;
  }

  .sm\\:max-h-\\[600px\\]{
    max-height: 600px;
  }

  .sm\\:max-h-\\[84vh\\]{
    max-height: 84vh;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:max-h-\\[calc\\(100dvh-3rem\\)\\]{
    max-height: calc(100dvh - 3rem);
  }

  .sm\\:max-h-\\[calc\\(100vh-1rem\\)\\]{
    max-height: calc(100vh - 1rem);
  }

  .sm\\:max-h-\\[min\\(660px\\2c calc\\(100dvh-1rem\\)\\)\\]{
    max-height: min(660px, calc(100dvh - 1rem));
  }

  .sm\\:max-h-full{
    max-height: 100%;
  }

  .sm\\:max-h-none{
    max-height: none;
  }

  .sm\\:min-h-0{
    min-height: 0px;
  }

  .sm\\:min-h-\\[6rem\\]{
    min-height: 6rem;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-20{
    width: 5rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-28{
    width: 7rem;
  }

  .sm\\:w-3\\.5{
    width: 0.875rem;
  }

  .sm\\:w-4{
    width: 1rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-52{
    width: 13rem;
  }

  .sm\\:w-56{
    width: 14rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-7{
    width: 1.75rem;
  }

  .sm\\:w-72{
    width: 18rem;
  }

  .sm\\:w-8{
    width: 2rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-9{
    width: 2.25rem;
  }

  .sm\\:w-\\[104px\\]{
    width: 104px;
  }

  .sm\\:w-\\[124px\\]{
    width: 124px;
  }

  .sm\\:w-\\[160px\\]{
    width: 160px;
  }

  .sm\\:w-\\[170px\\]{
    width: 170px;
  }

  .sm\\:w-\\[240px\\]{
    width: 240px;
  }

  .sm\\:w-\\[260px\\]{
    width: 260px;
  }

  .sm\\:w-\\[590px\\]{
    width: 590px;
  }

  .sm\\:w-\\[62px\\]{
    width: 62px;
  }

  .sm\\:w-\\[750px\\]{
    width: 750px;
  }

  .sm\\:w-\\[96vw\\]{
    width: 96vw;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:min-w-0{
    min-width: 0px;
  }

  .sm\\:min-w-\\[100px\\]{
    min-width: 100px;
  }

  .sm\\:min-w-\\[126px\\]{
    min-width: 126px;
  }

  .sm\\:min-w-\\[160px\\]{
    min-width: 160px;
  }

  .sm\\:min-w-\\[180px\\]{
    min-width: 180px;
  }

  .sm\\:min-w-\\[200px\\]{
    min-width: 200px;
  }

  .sm\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .sm\\:min-w-\\[260px\\]{
    min-width: 260px;
  }

  .sm\\:min-w-\\[28px\\]{
    min-width: 28px;
  }

  .sm\\:min-w-\\[6\\.5rem\\]{
    min-width: 6.5rem;
  }

  .sm\\:max-w-3xl{
    max-width: 48rem;
  }

  .sm\\:max-w-5xl{
    max-width: 64rem;
  }

  .sm\\:max-w-\\[13rem\\]{
    max-width: 13rem;
  }

  .sm\\:max-w-\\[140px\\]{
    max-width: 140px;
  }

  .sm\\:max-w-\\[160px\\]{
    max-width: 160px;
  }

  .sm\\:max-w-\\[190px\\]{
    max-width: 190px;
  }

  .sm\\:max-w-\\[220px\\]{
    max-width: 220px;
  }

  .sm\\:max-w-\\[240px\\]{
    max-width: 240px;
  }

  .sm\\:max-w-\\[45\\%\\]{
    max-width: 45%;
  }

  .sm\\:max-w-\\[575px\\]{
    max-width: 575px;
  }

  .sm\\:max-w-full{
    max-width: 100%;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:flex-1{
    flex: 1 1;
  }

  .sm\\:flex-\\[1\\.4\\]{
    flex: 1.4 1;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:shrink{
    flex-shrink: 1;
  }

  .sm\\:shrink-0{
    flex-shrink: 0;
  }

  .sm\\:grow-0{
    flex-grow: 0;
  }

  .sm\\:basis-0{
    flex-basis: 0px;
  }

  .sm\\:basis-\\[48rem\\]{
    flex-basis: 48rem;
  }

  .sm\\:basis-auto{
    flex-basis: auto;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1\\.5fr_1fr_1fr_1fr\\]{
    grid-template-columns: 1.5fr 1fr 1fr 1fr;
  }

  .sm\\:grid-cols-\\[9rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 9rem minmax(0,1fr);
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 180px\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,180px) minmax(0,1fr);
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-0\\.5{
    gap: 0.125rem;
  }

  .sm\\:gap-1{
    gap: 0.25rem;
  }

  .sm\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-x-2{
    column-gap: 0.5rem;
  }

  .sm\\:gap-y-1{
    row-gap: 0.25rem;
  }

  .sm\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .sm\\:overflow-visible{
    overflow: visible;
  }

  .sm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sm\\:whitespace-nowrap{
    white-space: nowrap;
  }

  .sm\\:rounded{
    border-radius: 0.25rem;
  }

  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }

  .sm\\:rounded-\\[4px\\]{
    border-radius: 4px;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:rounded-md{
    border-radius: calc(var(--radius) - 2px);
  }

  .sm\\:rounded-none{
    border-radius: 0px;
  }

  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }

  .sm\\:border{
    border-width: 1px;
  }

  .sm\\:border-0{
    border-width: 0px;
  }

  .sm\\:border-2{
    border-width: 2px;
  }

  .sm\\:border-x{
    border-left-width: 1px;
    border-right-width: 1px;
  }

  .sm\\:border-b{
    border-bottom-width: 1px;
  }

  .sm\\:border-b-0{
    border-bottom-width: 0px;
  }

  .sm\\:border-l{
    border-left-width: 1px;
  }

  .sm\\:border-r{
    border-right-width: 1px;
  }

  .sm\\:border-t{
    border-top-width: 1px;
  }

  .sm\\:border-\\[\\#25D366\\]\\/40{
    border-color: rgb(37 211 102 / 0.4);
  }

  .sm\\:border-rose-200{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-rose-200, 254 205 211) / var(--tw-border-opacity, 1));
  }

  .sm\\:border-slate-100{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-slate-100, 241 245 249) / var(--tw-border-opacity, 1));
  }

  .sm\\:border-slate-200{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
  }

  .sm\\:bg-\\[\\#25D366\\]\\/10{
    background-color: rgb(37 211 102 / 0.1);
  }

  .sm\\:bg-orange-50{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-orange-50, 255 247 237) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-sky-600{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-sky-600, 2 132 199) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-slate-100{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-slate-100\\/95{
    background-color: rgb(var(--bg-slate-100, 241 245 249) / 0.95);
  }

  .sm\\:bg-slate-50\\/60{
    background-color: rgb(var(--bg-slate-50, 248 250 252) / 0.6);
  }

  .sm\\:bg-slate-900{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-slate-900, 15 23 42) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-transparent{
    background-color: transparent;
  }

  .sm\\:bg-violet-100{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-violet-100, 237 233 254) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-1{
    padding: 0.25rem;
  }

  .sm\\:p-2{
    padding: 0.5rem;
  }

  .sm\\:p-2\\.5{
    padding: 0.625rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-3\\.5{
    padding: 0.875rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-3\\.5{
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-\\[5px\\]{
    padding-left: 5px;
    padding-right: 5px;
  }

  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-0{
    padding-bottom: 0px;
  }

  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-2{
    padding-left: 0.5rem;
  }

  .sm\\:pr-2{
    padding-right: 0.5rem;
  }

  .sm\\:pr-7{
    padding-right: 1.75rem;
  }

  .sm\\:pr-9{
    padding-right: 2.25rem;
  }

  .sm\\:pr-\\[10\\.375rem\\]{
    padding-right: 10.375rem;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:pt-12{
    padding-top: 3rem;
  }

  .sm\\:pt-2{
    padding-top: 0.5rem;
  }

  .sm\\:pt-3{
    padding-top: 0.75rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-center{
    text-align: center;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[12px\\]{
    font-size: 12px;
  }

  .sm\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .sm\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:font-medium{
    font-weight: 500;
  }

  .sm\\:font-semibold{
    font-weight: 600;
  }

  .sm\\:leading-6{
    line-height: 1.5rem;
  }

  .sm\\:leading-tight{
    line-height: 1.25;
  }

  .sm\\:tracking-wide{
    letter-spacing: 0.025em;
  }

  .sm\\:tracking-wider{
    letter-spacing: 0.05em;
  }

  .sm\\:text-\\[\\#128C7E\\]{
    --tw-text-opacity: 1;
    color: rgb(18 140 126 / var(--tw-text-opacity, 1));
  }

  .sm\\:text-orange-700{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-orange-700, 194 65 12) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-rose-500{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-rose-500, 244 63 94) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-sky-600{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-sky-600, 2 132 199) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-sky-800{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-sky-800, 7 89 133) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-slate-400{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-slate-500{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-500, 100 116 139) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-slate-700{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-700, 51 65 85) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-slate-900{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-900, 15 23 42) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-violet-700{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-violet-700, 109 40 217) / var(--tw-text-opacity, 1));
  }

  .sm\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }

  .sm\\:text-white\\/90{
    color: rgb(255 255 255 / 0.9);
  }

  .sm\\:opacity-100{
    opacity: 1;
  }

  .sm\\:shadow-2xl{
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:shadow-sm{
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:ring-2{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  .sm\\:ring-inset{
    --tw-ring-inset: inset;
  }

  .sm\\:ring-orange-200{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity, 1));
  }

  .sm\\:ring-sky-500{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
  }

  .sm\\:backdrop-blur{
    --tw-backdrop-blur: blur(8px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }

  .sm\\:\\[zoom\\:0\\.9\\]{
    zoom: 0.9;
  }

  .sm\\:hover\\:bg-slate-50:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
  }

  .sm\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .sm\\:hover\\:text-slate-800:hover{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-800, 30 41 59) / var(--tw-text-opacity, 1));
  }

  .sm\\:hover\\:shadow-sm:hover{
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:active\\:bg-\\[\\#25D366\\]\\/20:active{
    background-color: rgb(37 211 102 / 0.2);
  }

  .sm\\:active\\:bg-slate-100:active{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }

  @supports (backdrop-filter: var(--tw)){

    .sm\\:supports-\\[backdrop-filter\\]\\:bg-slate-100\\/80{
      background-color: rgb(var(--bg-slate-100, 241 245 249) / 0.8);
    }
  }

  @media not all and (min-width: 768px){

    .sm\\:max-md\\:\\[zoom\\:0\\.8\\]{
      zoom: 0.8;
    }
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:-right-2\\.5{
    right: -0.625rem;
  }

  .md\\:-top-1\\.5{
    top: -0.375rem;
  }

  .md\\:bottom-3{
    bottom: 0.75rem;
  }

  .md\\:bottom-4{
    bottom: 1rem;
  }

  .md\\:bottom-6{
    bottom: 1.5rem;
  }

  .md\\:right-6{
    right: 1.5rem;
  }

  .md\\:z-30{
    z-index: 30;
  }

  .md\\:order-1{
    order: 1;
  }

  .md\\:order-2{
    order: 2;
  }

  .md\\:order-3{
    order: 3;
  }

  .md\\:order-4{
    order: 4;
  }

  .md\\:order-5{
    order: 5;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:mb-4{
    margin-bottom: 1rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:contents{
    display: contents;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-7{
    height: 1.75rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:h-9{
    height: 2.25rem;
  }

  .md\\:h-auto{
    height: auto;
  }

  .md\\:w-14{
    width: 3.5rem;
  }

  .md\\:w-28{
    width: 7rem;
  }

  .md\\:w-32{
    width: 8rem;
  }

  .md\\:w-44{
    width: 11rem;
  }

  .md\\:w-9{
    width: 2.25rem;
  }

  .md\\:w-\\[11rem\\]{
    width: 11rem;
  }

  .md\\:w-\\[21rem\\]{
    width: 21rem;
  }

  .md\\:w-\\[240px\\]{
    width: 240px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:min-w-\\[10rem\\]{
    min-width: 10rem;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:flex-none{
    flex: none;
  }

  .md\\:shrink-0{
    flex-shrink: 0;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .md\\:gap-3{
    gap: 0.75rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .md\\:whitespace-normal{
    white-space: normal;
  }

  .md\\:border-0{
    border-width: 0px;
  }

  .md\\:border-b{
    border-bottom-width: 1px;
  }

  .md\\:border-b-0{
    border-bottom-width: 0px;
  }

  .md\\:border-slate-200{
    --tw-border-opacity: 1;
    border-color: rgb(var(--bd-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
  }

  .md\\:border-white{
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  }

  .md\\:bg-transparent{
    background-color: transparent;
  }

  .md\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--bg-white, 255 255 255) / var(--tw-bg-opacity, 1));
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .md\\:pb-0{
    padding-bottom: 0px;
  }

  .md\\:pb-1\\.5{
    padding-bottom: 0.375rem;
  }

  .md\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .md\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:font-medium{
    font-weight: 500;
  }

  .md\\:leading-normal{
    line-height: 1.5;
  }

  .md\\:text-sky-600{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-sky-600, 2 132 199) / var(--tw-text-opacity, 1));
  }

  .md\\:text-slate-300{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-300, 203 213 225) / var(--tw-text-opacity, 1));
  }

  .md\\:text-slate-400{
    --tw-text-opacity: 1;
    color: rgb(var(--tx-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
  }

  .md\\:opacity-70{
    opacity: 0.7;
  }
}
@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[calc\\(100vh-220px\\)\\]{
    height: calc(100vh - 220px);
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:w-28{
    width: 7rem;
  }

  .lg\\:w-36{
    width: 9rem;
  }

  .lg\\:w-52{
    width: 13rem;
  }

  .lg\\:w-72{
    width: 18rem;
  }

  .lg\\:w-\\[19\\.5rem\\]{
    width: 19.5rem;
  }

  .lg\\:w-\\[20rem\\]{
    width: 20rem;
  }

  .lg\\:w-\\[22rem\\]{
    width: 22rem;
  }

  .lg\\:w-\\[24rem\\]{
    width: 24rem;
  }

  .lg\\:w-\\[25rem\\]{
    width: 25rem;
  }

  .lg\\:w-\\[26rem\\]{
    width: 26rem;
  }

  .lg\\:w-\\[28rem\\]{
    width: 28rem;
  }

  .lg\\:w-full{
    width: 100%;
  }

  .lg\\:max-w-sm{
    max-width: 24rem;
  }

  .lg\\:flex-1{
    flex: 1 1;
  }

  .lg\\:flex-none{
    flex: none;
  }

  .lg\\:shrink{
    flex-shrink: 1;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-start{
    justify-content: flex-start;
  }

  .lg\\:gap-3{
    gap: 0.75rem;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:overflow-x-visible{
    overflow-x: visible;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:p-3{
    padding: 0.75rem;
  }
}
@media (min-width: 1280px){

  .xl\\:block{
    display: block;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .xl\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .xl\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .xl\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:flex{
    display: flex;
  }

  .\\32xl\\:hidden{
    display: none;
  }

  .\\32xl\\:w-32{
    width: 8rem;
  }

  .\\32xl\\:w-40{
    width: 10rem;
  }

  .\\32xl\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .\\32xl\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .\\32xl\\:gap-2{
    gap: 0.5rem;
  }

  .\\32xl\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .\\32xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:text-\\[13px\\]{
    font-size: 13px;
  }
}
@media (min-width: 1900px){

  .min-\\[1900px\\]\\:gap-1\\.5{
    gap: 0.375rem;
  }

  .min-\\[1900px\\]\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .min-\\[1900px\\]\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .min-\\[1900px\\]\\:px-3\\.5{
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .min-\\[1900px\\]\\:pr-3{
    padding-right: 0.75rem;
  }

  .min-\\[1900px\\]\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\*\\:last-child\\]\\:col-span-2>*:last-child{
  grid-column: span 2 / span 2;
}
@media (min-width: 1024px){

  .lg\\:\\[\\&\\>\\*\\:last-child\\]\\:col-span-1>*:last-child{
    grid-column: span 1 / span 1;
  }
}
.\\[\\&\\>\\*\\]\\:min-w-0>*{
  min-width: 0px;
}
.\\[\\&\\>\\*\\]\\:flex-1>*{
  flex: 1 1;
}
.\\[\\&\\>\\*\\]\\:shrink-0>*{
  flex-shrink: 0;
}
@media not all and (min-width: 640px){

  .max-sm\\:\\[\\&\\>\\*\\]\\:basis-\\[calc\\(\\(100\\%_-_16px\\)\\/5\\)\\]>*{
    flex-basis: calc((100% - 16px) / 5);
  }
}
@media (min-width: 640px){

  .sm\\:\\[\\&\\>\\*\\]\\:flex-none>*{
    flex: none;
  }

  .sm\\:\\[\\&\\>\\*\\]\\:shrink-0>*{
    flex-shrink: 0;
  }
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>button\\:last-child\\]\\:top-5>button:last-child{
  top: 1.25rem;
}
@media (min-width: 640px){

  .sm\\:\\[\\&\\>button\\:last-child\\]\\:top-4>button:last-child{
    top: 1rem;
  }
}
.\\[\\&\\>button\\]\\:mb-0>button{
  margin-bottom: 0px;
}
.\\[\\&\\>div\\>button\\:first-child\\]\\:w-8>div>button:first-child{
  width: 2rem;
}
.\\[\\&\\>div\\>button\\:first-child\\]\\:min-w-9>div>button:first-child{
  min-width: 2.25rem;
}
.\\[\\&\\>div\\>button\\]\\:h-8>div>button{
  height: 2rem;
}
.\\[\\&\\>div\\>button\\]\\:h-9>div>button{
  height: 2.25rem;
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>td\\]\\:px-1\\.5>td{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.\\[\\&\\>th\\]\\:truncate>th{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.\\[\\&\\>th\\]\\:whitespace-nowrap>th{
  white-space: nowrap;
}
.\\[\\&\\>th\\]\\:px-1\\.5>th{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\.rounded-lg\\]\\:\\!rounded-\\[4px\\] .rounded-lg{
  border-radius: 4px !important;
}
.\\[\\&_\\.rounded-md\\]\\:\\!rounded-\\[4px\\] .rounded-md{
  border-radius: 4px !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_button\\>span\\:first-child\\]\\:h-\\[26px\\] button>span:first-child{
  height: 26px;
}
.\\[\\&_button\\>span\\:first-child\\]\\:w-\\[26px\\] button>span:first-child{
  width: 26px;
}
.\\[\\&_button\\]\\:h-10 button{
  height: 2.5rem;
}
.\\[\\&_button\\]\\:h-8 button{
  height: 2rem;
}
.\\[\\&_button\\]\\:h-9 button{
  height: 2.25rem;
}
.\\[\\&_button\\]\\:h-\\[30px\\] button{
  height: 30px;
}
.\\[\\&_button\\]\\:w-full button{
  width: 100%;
}
.\\[\\&_button\\]\\:justify-center button{
  justify-content: center;
}
.\\[\\&_button\\]\\:rounded button{
  border-radius: 0.25rem;
}
.\\[\\&_button\\]\\:rounded-md button{
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&_button\\]\\:px-1 button{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.\\[\\&_button\\]\\:px-2 button{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_button\\]\\:px-3 button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.\\[\\&_button\\]\\:pb-1 button{
  padding-bottom: 0.25rem;
}
.\\[\\&_button\\]\\:pt-0\\.5 button{
  padding-top: 0.125rem;
}
.\\[\\&_button\\]\\:text-\\[11px\\] button{
  font-size: 11px;
}
.\\[\\&_button\\]\\:text-xs button{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_button\\]\\:font-semibold button{
  font-weight: 600;
}
@media (min-width: 640px){

  .sm\\:\\[\\&_button\\]\\:h-10 button{
    height: 2.5rem;
  }

  .sm\\:\\[\\&_button\\]\\:w-auto button{
    width: auto;
  }

  .sm\\:\\[\\&_button\\]\\:px-2\\.5 button{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:\\[\\&_button\\]\\:px-4 button{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:\\[\\&_button\\]\\:text-sm button{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:\\[\\&_button\\]\\:text-xs button{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:\\[\\&_button\\]\\:px-3 button{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:\\[\\&_button\\]\\:text-\\[13px\\] button{
    font-size: 13px;
  }
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:mr-1\\.5 svg{
  margin-right: 0.375rem;
}
.\\[\\&_svg\\]\\:hidden svg{
  display: none;
}
.\\[\\&_svg\\]\\:size-3\\.5 svg{
  width: 0.875rem;
  height: 0.875rem;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:h-3\\.5 svg{
  height: 0.875rem;
}
.\\[\\&_svg\\]\\:w-3\\.5 svg{
  width: 0.875rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
@media not all and (min-width: 640px){

  .max-sm\\:\\[\\&_svg\\]\\:\\!size-3\\.5 svg{
    width: 0.875rem !important;
    height: 0.875rem !important;
  }
}
@media (min-width: 640px){

  .sm\\:\\[\\&_svg\\]\\:inline-block svg{
    display: inline-block;
  }
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;QAAA,uBAAc;QAAd,yBAAc;QAAd,iBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,qBAAc;QAAd,gCAAc;QAAd,4BAAc;QAAd,kCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,gBAAc;IAAA;IAAd;EAAA;AAAc;IAAd;EAAA,wCAAc;EAAd,6BAAc;QAAd;AAAc;IAAd;;;;;;QAAA,kCAAc;IAAA;IAAd;;;QAAA,qBAAc;QAAd,wBAAc;IAAA;;IAAd;;;QAAA,aAAc;QAAd,QAAc;QAAd,SAAc;IAAA;IAAd;QAAA,4BAAc;IAAA;;IAAd;QAAA,oBAAc;QAAd,qBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,uBAAc;QAAd,mBAAc;QAAd,gBAAc;QAAd,YAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;IAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6FAAmB;EAAnB,yFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6FAAmB;EAAnB,yFAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,SAAS;IACT,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAkDA;;;;4EAI4E;;AAkB5E;;;;;;;wBAOwB;AACxB;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;QACrB,oCAAoC;IACxC;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;;;;iCAKiC;AACjC;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAkCA;;gEAEgE;AAChE;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;AAC1B;AACA;iBACiB;AACjB;EACE,oCAAoC,EAAE,YAAY;EAClD,sBAAsB;EACtB,aAAa;AACf;AACA;oDACoD;AACpD;;;EAGE,wDAAwD;AAC1D;AACA;;qCAEqC;AACrC;EACE,8BAA8B;AAChC;AACA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE;;;IAGE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;AACA;;;;;;;;uCAQuC;AACvC;;;;;;;;;;;;;;;;;EAiBE,wCAAwC;EACxC,2BAA2B;EAC3B,oCAAoC,EAAE,aAAa;EACnD,6BAA6B;AAC/B;AACA;;;;;EAKE,oCAAoC,EAAE,cAAc;AACtD;AACA;;;;;;;EAOE,yBAAyB,EAAE,eAAe;AAC5C;AACA;;;;;;;EAOE,oCAAoC,EAAE,cAAc;EACpD,yBAAyB,EAAE,eAAe;AAC5C;AACA;;EAEE,yBAAyB,EAAE,eAAe;AAC5C;AACA;;EAEE,oCAAoC,EAAE,cAAc;EACpD,yBAAyB,EAAE,eAAe;AAC5C;AACA;;EAEE,yBAAyB,EAAE,aAAa;AAC1C;AACA;;EAEE,oCAAoC,EAAE,YAAY;EAClD,yBAAyB,EAAE,aAAa;AAC1C;AACA,iGAAiG;AACjG;EACE,yBAAyB,EAAE,cAAc;AAC3C;AACA;EACE,yBAAyB,EAAE,aAAa;AAC1C;AACA;kFACkF;AAClF;EACE,yBAAyB,EAAE,cAAc;AAC3C;AACA;;EAEE,yBAAyB,EAAE,YAAY;EACvC,UAAU;AACZ;AACA;EACE,yBAAyB,EAAE,aAAa;AAC1C;AACA,oEAAoE;AACpE;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB,EAAE,YAAY;EACvC,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;wCACwC;AACxC;EACE,iCAAiC;AACnC;AA9VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,mBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA,QA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,iDA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kDA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,0EA+VA;EA/VA,8FA+VA;EA/VA;AA+VA;AA/VA;EAAA,yEA+VA;EA/VA,wFA+VA;EA/VA;AA+VA;AA/VA;EAAA,yEA+VA;EA/VA,wFA+VA;EA/VA;AA+VA;AA/VA;EAAA,6EA+VA;EA/VA,iGA+VA;EA/VA;AA+VA;AA/VA;EAAA,0CA+VA;EA/VA,uDA+VA;EA/VA;AA+VA;AA/VA;EAAA,gCA+VA;EA/VA;AA+VA;AA/VA;EAAA,iCA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,iBA+VA;EA/VA,iBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,iCA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,+BA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,+EA+VA;EA/VA,mGA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,yBA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,yBA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA,gDA+VA;EA/VA;AA+VA;AA/VA;EAAA,iDA+VA;EA/VA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,0EA+VA;EA/VA,8FA+VA;EA/VA;AA+VA;AA/VA;EAAA,2GA+VA;EA/VA,yGA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA,yBA+VA;EA/VA,2BA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,+BA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA,yBA+VA;EA/VA,2BA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,+BA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA,yBA+VA;EA/VA,2BA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,+BA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,wBA+VA;EA/VA,yBA+VA;EA/VA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,wBA+VA;EA/VA,yBA+VA;EA/VA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,wBA+VA;EA/VA,yBA+VA;EA/VA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA,yBA+VA;EA/VA,0BA+VA;EA/VA,wBA+VA;EA/VA,yBA+VA;EA/VA,8BA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,0BA+VA;EA/VA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,mBA+VA;EA/VA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;;IAAA;MAAA;IA+VA;;IA/VA;MAAA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA,2BA+VA;MA/VA;IA+VA;;IA/VA;MAAA,eA+VA;MA/VA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA;IA+VA;;IA/VA;MAAA;IA+VA;;IA/VA;MAAA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA;IA+VA;;IA/VA;MAAA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA;IA+VA;;IA/VA;MAAA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA,mBA+VA;MA/VA;IA+VA;EAAA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA,yBA+VA;IA/VA,2BA+VA;IA/VA,yBA+VA;IA/VA,0BA+VA;IA/VA,+BA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA,gBA+VA;IA/VA,gBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,2DA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,+DA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,gBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,gBA+VA;IA/VA,oBA+VA;IA/VA,4BA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,mDA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,sDA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,oDA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,2DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,4DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,+DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,uBA+VA;IA/VA,8DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,wBA+VA;IA/VA,0DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,wBA+VA;IA/VA,kEA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,gBA+VA;IA/VA,uBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,iBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,iBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,iBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,eA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,gDA+VA;IA/VA,6DA+VA;IA/VA;EA+VA;;EA/VA;IAAA,6EA+VA;IA/VA,iGA+VA;IA/VA;EA+VA;;EA/VA;IAAA,0CA+VA;IA/VA,uDA+VA;IA/VA;EA+VA;;EA/VA;IAAA,2GA+VA;IA/VA,yGA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,6BA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,0CA+VA;IA/VA,uDA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;;IAAA;MAAA;IA+VA;EAAA;;EA/VA;;IAAA;MAAA;IA+VA;EAAA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,wBA+VA;IA/VA,kEA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,iBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,oBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,iBA+VA;IA/VA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;AAAA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kDA+VA;EA/VA;AA+VA;AA/VA;EAAA,iDA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,iDA+VA;EA/VA;AA+VA;AA/VA;EAAA,kDA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kDA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,gBA+VA;EA/VA,oBA+VA;EA/VA,4BA+VA;EA/VA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,WA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA,gBA+VA;EA/VA,uBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,sBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA,mBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA,oBA+VA;EA/VA;AA+VA;AA/VA;EAAA,qBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,kBA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA;EA+VA;;EA/VA;IAAA;EA+VA;;EA/VA;IAAA,sBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,mBA+VA;IA/VA;EA+VA;;EA/VA;IAAA,kBA+VA;IA/VA;EA+VA;AAAA;AA/VA;;EAAA;IAAA,qBA+VA;IA/VA;EA+VA;;EA/VA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA,eA+VA;EA/VA;AA+VA;AA/VA;EAAA,WA+VA;EA/VA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA;AA/VA;;EAAA;IAAA,0BA+VA;IA/VA;EA+VA;AAAA;AA/VA;;EAAA;IAAA;EA+VA;AAAA;AA/VA;EAAA;AA+VA;AA/VA;EAAA;AA+VA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&family=Lexend:wght@400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n    margin: 0;\n    font-family: \"Inter\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: \"JetBrains Mono\", monospace;\n}\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --foreground: 222 47% 11%;\n        --card: 0 0% 100%;\n        --card-foreground: 222 47% 11%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 222 47% 11%;\n        --primary: 198 93% 49%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 210 40% 96%;\n        --secondary-foreground: 222 47% 11%;\n        --muted: 210 40% 96%;\n        --muted-foreground: 215 16% 47%;\n        --accent: 198 93% 96%;\n        --accent-foreground: 198 93% 35%;\n        --destructive: 0 84.2% 60.2%;\n        --destructive-foreground: 0 0% 98%;\n        --border: 214 32% 91%;\n        --input: 214 32% 91%;\n        --ring: 198 93% 49%;\n        --chart-1: 24 95% 53%;\n        --chart-2: 198 93% 49%;\n        --chart-3: 222 47% 21%;\n        --chart-4: 39 93% 56%;\n        --chart-5: 160 84% 39%;\n        --radius: 0.5rem;\n    }\n}\n\n@layer base {\n    * {\n        @apply border-border;\n    }\n    body {\n        @apply bg-background text-foreground;\n        font-family: \"Inter\", sans-serif;\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        font-family: \"Manrope\", sans-serif;\n    }\n}\n\n/* No visible scrollbars anywhere in the OS — not down the side of the page, not\n   inside a panel or a dialog. Scrolling itself is untouched: wheel, trackpad,\n   touch, keyboard and drag all still work exactly as before; only the drawn\n   track and thumb are gone. Both syntaxes are needed — Firefox reads\n   scrollbar-width, Chrome and Safari only respond to ::-webkit-scrollbar. */\n@layer base {\n    html,\n    body,\n    * {\n        scrollbar-width: none;\n        -ms-overflow-style: none;\n    }\n\n    html::-webkit-scrollbar,\n    body::-webkit-scrollbar,\n    *::-webkit-scrollbar {\n        display: none;\n        width: 0;\n        height: 0;\n    }\n}\n\n/* The one exception, opted into per element: a strip wider than the screen whose\n   overflow a mouse user would otherwise never find (Operations > Branch's tab row).\n   Outside the base layer so it beats the `*` rule above.\n\n   Chrome 121+ draws its own native bar (grey, with arrow buttons) whenever\n   scrollbar-width / scrollbar-color are set, and then ignores ::-webkit-scrollbar.\n   So those two go to Firefox alone, and Chrome/Safari get the styled pseudo-elements\n   in the theme's sky. */\n.show-scrollbar {\n    scrollbar-width: auto;\n    scrollbar-color: auto;\n}\n\n@supports not selector(::-webkit-scrollbar) {\n    .show-scrollbar {\n        scrollbar-width: thin;\n        scrollbar-color: #7dd3fc transparent;\n    }\n}\n\n.show-scrollbar::-webkit-scrollbar {\n    display: block;\n    height: 5px;\n}\n\n.show-scrollbar::-webkit-scrollbar-button {\n    display: none;\n}\n\n.show-scrollbar::-webkit-scrollbar-thumb {\n    background: #bae6fd;\n    border-radius: 9999px;\n}\n\n.show-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: #38bdf8;\n}\n\n.show-scrollbar::-webkit-scrollbar-track {\n    background: transparent;\n    margin: 0 8px;\n}\n\n/* A tab's notification badge (Accountant Manage), cycling round the RGB spectrum. A\n   hue-rotate filter on the badge's wrapper, so the ping ring and the core turn together\n   while white -- the count and the ring round the badge -- stays white, and the rotation\n   holds lightness, so the count reads as well on green or blue as it does on red. The\n   badge only; the tab under it keeps its own colour. Stands still in its base colour for\n   a desk set to reduce motion. */\n@keyframes rgb-badge-cycle {\n    from {\n        filter: hue-rotate(0deg);\n    }\n    to {\n        filter: hue-rotate(360deg);\n    }\n}\n\n.rgb-badge {\n    animation: rgb-badge-cycle 3s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .rgb-badge {\n        animation: none;\n    }\n}\n\n@layer base {\n    [data-debug-wrapper=\"true\"] {\n        display: contents !important;\n    }\n\n    [data-debug-wrapper=\"true\"] > * {\n        margin-left: inherit;\n        margin-right: inherit;\n        margin-top: inherit;\n        margin-bottom: inherit;\n        padding-left: inherit;\n        padding-right: inherit;\n        padding-top: inherit;\n        padding-bottom: inherit;\n        column-gap: inherit;\n        row-gap: inherit;\n        gap: inherit;\n        border-left-width: inherit;\n        border-right-width: inherit;\n        border-top-width: inherit;\n        border-bottom-width: inherit;\n        border-left-style: inherit;\n        border-right-style: inherit;\n        border-top-style: inherit;\n        border-bottom-style: inherit;\n        border-left-color: inherit;\n        border-right-color: inherit;\n        border-top-color: inherit;\n        border-bottom-color: inherit;\n    }\n}\n\n/* Branch Admin > Consultation: the Overview tab of a patient at Consultation Visit or Fee Collected is drawn flat --\n   no borders, 2px corners, and its buttons (View Details, Receipt) carry no\n   icon. Round things (the step numbers and ticks) stay round. */\n.fee-flat,\n.fee-flat * {\n  border-style: none !important;\n}\n.fee-flat [class*=\"rounded\"]:not(.rounded-full),\n.fee-flat button:not(.rounded-full) {\n  border-radius: 2px !important;\n}\n.fee-flat [data-testid=\"cons-case-record-open\"] > span.ml-auto svg,\n.fee-flat [data-testid^=\"cons-fee-receipt\"] svg {\n  display: none !important;\n}\n/* ...and View Details is filled in its own colour, at 75% (set\n   in the JSX). */\n.fee-flat [data-testid=\"cons-case-record-view\"] {\n  background-color: #0284c7 !important; /* sky-600 */\n  color: #fff !important;\n  opacity: 0.75;\n}\n/* ...and every button down the right-hand side casts a shadow under its bottom edge only:\n   the negative spread pulls it in from the sides. */\n.fee-flat [data-testid=\"cons-case-record-view\"],\n.fee-flat [data-testid^=\"cons-fee-receipt\"],\n.fee-flat [data-testid^=\"cons-fee-act-\"] {\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.7) !important;\n}\n/* ...and its buttons down the right-hand side -- View Details, every Receipt and\n   Collect -- are one size and end on one edge: the fee rows take the same 16px\n   inset the section headings have. */\n.fee-flat [data-testid^=\"cons-fee-step-\"] {\n  padding-right: 16px !important;\n}\n.fee-flat [data-testid=\"cons-case-record-view\"],\n.fee-flat [data-testid^=\"cons-fee-receipt\"],\n.fee-flat [data-testid^=\"cons-fee-act-\"] {\n  width: 104px !important;\n  min-width: 104px !important;\n  height: 32px !important;\n  padding: 0 8px !important;\n  justify-content: center !important;\n  font-size: 12px !important;\n}\n@media (min-width: 640px) {\n  .fee-flat [data-testid=\"cons-case-record-view\"],\n  .fee-flat [data-testid^=\"cons-fee-receipt\"],\n  .fee-flat [data-testid^=\"cons-fee-act-\"] {\n    width: 130px !important;\n    min-width: 130px !important;\n  }\n}\n/* Fee Collected's buttons (.fee-soft, set in the JSX), drawn the same way on Consultation\n   Visit, Physio Assign and the popup opened from the Rehab, Diet Consultation and Diet Chart\n   pills: no button on the Overview is filled or casts a shadow -- each is its words and icon\n   in colour on the white of its row, with 2px corners. The footer's Assign Physio, Mark Online\n   and Add Due (and Collect Online Payment beside them) share one pastel violet, as do the\n   Treatment Fee row's Mark Online and Physio Assign's Assign / Reassign Physio. Diet's buttons\n   read in orange, Rehab's in cyan. A light tint shows on hover. The\n   buttons alone take a 1px gray border; the rest of the Overview keeps its own borders, and\n   the tab rows are left as they are. */\n.fee-soft [data-testid=\"cons-case-record-view\"],\n.fee-soft [data-testid^=\"cons-fee-receipt\"],\n.fee-soft [data-testid^=\"cons-fee-act-\"],\n.fee-soft :is([data-testid^=\"cons-fee-inspect-treatment\"], [data-testid=\"cons-fee-inspect-extra\"]),\n.fee-soft [data-testid^=\"cons-prebook-use-\"],\n.fee-soft [data-testid=\"cons-fee-mark-online\"],\n.fee-soft [data-testid=\"cons-open-physio-assign-from-fee-collected\"],\n.fee-soft [data-testid=\"cons-mark-online-menu\"],\n.fee-soft [data-testid=\"cons-open-add-due\"],\n.fee-soft [data-testid=\"cons-collect-online\"],\n.fee-soft [data-testid=\"cons-open-physio-assign\"],\n.fee-soft [data-testid=\"cons-reassign-physio\"],\n.fee-soft [data-testid=\"cons-physio-assign-collect-balance\"],\n.fee-soft [data-testid^=\"cons-diet-detail-\"],\n.fee-soft [data-testid=\"cons-open-diet-assign\"],\n.fee-soft [data-testid^=\"cons-rehab-detail-\"],\n.fee-soft [data-testid=\"cons-open-rehab-fee\"] {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: 1px solid #d1d5db !important; /* gray-300 */\n  border-radius: 2px !important;\n}\n.fee-soft [data-testid=\"cons-case-record-view\"]:hover,\n.fee-soft [data-testid^=\"cons-fee-receipt\"]:hover,\n.fee-soft [data-testid^=\"cons-fee-act-\"]:hover,\n.fee-soft [data-testid^=\"cons-prebook-use-\"]:hover,\n.fee-soft [data-testid=\"cons-physio-assign-collect-balance\"]:hover {\n  background-color: #f1f5f9 !important; /* slate-100 */\n}\n.fee-soft [data-testid=\"cons-fee-mark-online\"],\n.fee-soft [data-testid=\"cons-open-physio-assign-from-fee-collected\"],\n.fee-soft [data-testid=\"cons-mark-online-menu\"],\n.fee-soft [data-testid=\"cons-open-add-due\"],\n.fee-soft [data-testid=\"cons-collect-online\"],\n.fee-soft [data-testid=\"cons-open-physio-assign\"],\n.fee-soft [data-testid=\"cons-reassign-physio\"] {\n  color: #8b5cf6 !important; /* violet-500 */\n}\n.fee-soft [data-testid=\"cons-fee-mark-online\"]:hover,\n.fee-soft [data-testid=\"cons-open-physio-assign-from-fee-collected\"]:hover,\n.fee-soft [data-testid=\"cons-mark-online-menu\"]:hover,\n.fee-soft [data-testid=\"cons-open-add-due\"]:hover,\n.fee-soft [data-testid=\"cons-collect-online\"]:hover,\n.fee-soft [data-testid=\"cons-open-physio-assign\"]:hover,\n.fee-soft [data-testid=\"cons-reassign-physio\"]:hover {\n  background-color: #f5f3ff !important; /* violet-50 */\n  color: #7c3aed !important; /* violet-600 */\n}\n.fee-soft [data-testid^=\"cons-diet-detail-\"],\n.fee-soft [data-testid=\"cons-open-diet-assign\"] {\n  color: #ea580c !important; /* orange-600 */\n}\n.fee-soft [data-testid^=\"cons-diet-detail-\"]:hover,\n.fee-soft [data-testid=\"cons-open-diet-assign\"]:hover {\n  background-color: #fff7ed !important; /* orange-50 */\n  color: #c2410c !important; /* orange-700 */\n}\n.fee-soft [data-testid^=\"cons-rehab-detail-\"],\n.fee-soft [data-testid=\"cons-open-rehab-fee\"] {\n  color: #0891b2 !important; /* cyan-600 */\n}\n.fee-soft [data-testid^=\"cons-rehab-detail-\"]:hover,\n.fee-soft [data-testid=\"cons-open-rehab-fee\"]:hover {\n  background-color: #ecfeff !important; /* cyan-50 */\n  color: #0e7490 !important; /* cyan-700 */\n}\n/* Physio Assign's Collect Balance reads in the amber of the box it sits in, rose once overdue. */\n.fee-soft [data-testid=\"cons-physio-assign-collect-balance\"] {\n  color: #b45309 !important; /* amber-700 */\n}\n.fee-soft [data-testid=\"cons-physio-assign-collect-balance\"].bg-rose-600 {\n  color: #e11d48 !important; /* rose-600 */\n}\n/* View Details and the next fee's Collect keep their sky as the colour of their words; the\n   other Collects read in slate, and Receipt keeps its emerald (set in the JSX). */\n.fee-soft [data-testid^=\"cons-fee-act-\"] {\n  color: #334155 !important; /* slate-700 */\n}\n.fee-soft [data-testid=\"cons-case-record-view\"],\n.fee-soft [data-testid^=\"cons-fee-act-\"].bg-sky-600 {\n  color: #0284c7 !important; /* sky-600 */\n  opacity: 1;\n}\n.fee-soft [data-testid^=\"cons-prebook-use-\"] {\n  color: #0f766e !important; /* teal-700 */\n}\n/* Inspect is as wide as its word, under the Treatment Fee's name. */\n.fee-soft :is([data-testid^=\"cons-fee-inspect-treatment\"], [data-testid=\"cons-fee-inspect-extra\"]) {\n  width: auto !important;\n  padding: 0 6px !important;\n  justify-content: flex-start !important;\n  color: #0284c7 !important; /* sky-600 */\n  opacity: 1;\n}\n.fee-soft :is([data-testid^=\"cons-fee-inspect-treatment\"], [data-testid=\"cons-fee-inspect-extra\"]):hover {\n  text-decoration: underline;\n}\n/* ...and on Fee Collected alone (.fee-collected), the rows of fees already in sit on white\n   like the rest, not on a green tint. */\n.fee-collected [data-testid^=\"cons-fee-step-\"] {\n  background-color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
